(function () {
'use strict';

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _library = false;

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode: _library ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

_core.inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

var _iterators = {};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

// check on default Array iterator

var ITERATOR = _wks('iterator');
var ArrayProto = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR] === it);
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
  else object[index] = value;
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var ITERATOR$1 = _wks('iterator');

var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$1]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var ITERATOR$2 = _wks('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$2]();
  riter['return'] = function () { SAFE_CLOSING = true; };
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$2]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$2] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

_export(_export.S + _export.F * !_iterDetect(function (iter) { }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

var f$1 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$1
};

var f$2 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$2
};

// 19.1.2.1 Object.assign(target, source, ...)





var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

var f$3 = _wks;

var _wksExt = {
	f: f$3
};

var defineProperty = _objectDp.f;
var _wksDefine = function (name) {
  var $Symbol = _core.Symbol || (_core.Symbol = _library ? {} : _global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: _wksExt.f(name) });
};

_wksDefine('asyncIterator');

var _meta = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var def = _objectDp.f;

var TAG$1 = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG$1)) def(it, TAG$1, { configurable: true, value: tag });
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys(it);
  var getSymbols = _objectGops.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$4
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn.f;
var toString$1 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
};

var _objectGopnExt = {
	f: f$5
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$6
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;



















var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE$2 = 'prototype';
var HIDDEN = _wks('_hidden');
var TO_PRIMITIVE = _wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = _shared('symbol-registry');
var AllSymbols = _shared('symbols');
var OPSymbols = _shared('op-symbols');
var ObjectProto = Object[PROTOTYPE$2];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = _global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP$1({}, 'a', {
    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$1(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP$1(it, key, D);
  if (protoDesc && it !== ObjectProto) dP$1(ObjectProto, key, protoDesc);
} : dP$1;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  _anObject(it);
  key = _toPrimitive(key, true);
  _anObject(D);
  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP$1(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject(it);
  var keys = _enumKeys(P = _toIobject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD$1(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };
    if (_descriptors && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return this._k;
  });

  _objectGopd.f = $getOwnPropertyDescriptor;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;

  if (_descriptors && !_library) {
    _redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!_isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag(_global.JSON, 'JSON', true);

var _anInstance = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

var _forOf = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
  var f = _ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES = _wks('species');
var _speciesConstructor = function (O, D) {
  var C = _anObject(O).constructor;
  var S;
  return C === undefined || (S = _anObject(C)[SPECIES]) == undefined ? D : _aFunction(S);
};

// fast apply, http://jsperf.lnkit.com/fast-apply/5
var _invoke = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

var process = _global.process;
var setTask = _global.setImmediate;
var clearTask = _global.clearImmediate;
var MessageChannel = _global.MessageChannel;
var Dispatch = _global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (_cof(process) == 'process') {
    defer = function (id) {
      process.nextTick(_ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(_ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = _ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
    defer = function (id) {
      _global.postMessage(id + '', '*');
    };
    _global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in _domCreate('script')) {
    defer = function (id) {
      _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
        _html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(_ctx(run, id, 1), 0);
    };
  }
}
var _task = {
  set: setTask,
  clear: clearTask
};

var macrotask = _task.set;
var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
var process$1 = _global.process;
var Promise$1 = _global.Promise;
var isNode = _cof(process$1) == 'process';

var _microtask = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process$1.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise$1.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(_global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

// 25.4.1.5 NewPromiseCapability(C)


function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = _aFunction(resolve);
  this.reject = _aFunction(reject);
}

var f$7 = function (C) {
  return new PromiseCapability(C);
};

var _newPromiseCapability = {
	f: f$7
};

var _perform = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

var navigator = _global.navigator;

var _userAgent = navigator && navigator.userAgent || '';

var _promiseResolve = function (C, x) {
  _anObject(C);
  if (_isObject(x) && x.constructor === C) return x;
  var promiseCapability = _newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var _redefineAll = function (target, src, safe) {
  for (var key in src) _redefine(target, key, src[key], safe);
  return target;
};

var SPECIES$1 = _wks('species');

var _setSpecies = function (KEY) {
  var C = _global[KEY];
  if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
    configurable: true,
    get: function () { return this; }
  });
};

var task = _task.set;
var microtask = _microtask();




var PROMISE = 'Promise';
var TypeError$1 = _global.TypeError;
var process$2 = _global.process;
var versions = process$2 && process$2.versions;
var v8 = versions && versions.v8 || '';
var $Promise = _global[PROMISE];
var isNode$1 = _classof(process$2) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

var USE_NATIVE$1 = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && _userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(_global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = _perform(function () {
        if (isNode$1) {
          process$2.emit('unhandledRejection', value, promise);
        } else if (handler = _global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = _global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(_global, function () {
    var handler;
    if (isNode$1) {
      process$2.emit('rejectionHandled', promise);
    } else if (handler = _global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE$1) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    _anInstance(this, $Promise, PROMISE, '_h');
    _aFunction(executor);
    Internal.call(this);
    try {
      executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = _redefineAll($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode$1 ? process$2.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = _ctx($resolve, promise, 1);
    this.reject = _ctx($reject, promise, 1);
  };
  _newPromiseCapability.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE$1, { Promise: $Promise });
_setToStringTag($Promise, PROMISE);
_setSpecies(PROMISE);
Wrapper = _core[PROMISE];

// statics
_export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
_export(_export.S + _export.F * (_library || !USE_NATIVE$1), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return _promiseResolve(_library && this === Wrapper ? $Promise : this, x);
  }
});
_export(_export.S + _export.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = _perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      _forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = _perform(function () {
      _forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

var _fixReWks = function (KEY, length, exec) {
  var SYMBOL = _wks(KEY);
  var fns = exec(_defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (_fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    _redefine(String.prototype, KEY, strfn);
    _hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

// @@replace logic
_fixReWks('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = _wks('unscopables');
var ArrayProto$1 = Array.prototype;
if (ArrayProto$1[UNSCOPABLES] == undefined) _hide(ArrayProto$1, UNSCOPABLES, {});
var _addToUnscopables = function (key) {
  ArrayProto$1[UNSCOPABLES][key] = true;
};

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto$1 = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto$1 : null;
};

var ITERATOR$3 = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR$3] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!_library && typeof IteratorPrototype[ITERATOR$3] != 'function') _hide(IteratorPrototype, ITERATOR$3, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR$3])) {
    _hide(proto, ITERATOR$3, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

_addToUnscopables('keys');
_addToUnscopables('values');
_addToUnscopables('entries');

var dP$2 = _objectDp.f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || _descriptors && dP$2(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

// @@search logic
_fixReWks('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

var ITERATOR$4 = _wks('iterator');
var TO_STRING_TAG = _wks('toStringTag');
var ArrayValues = _iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME$1 = collections[i];
  var explicit = DOMIterables[NAME$1];
  var Collection = _global[NAME$1];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR$4]) _hide(proto, ITERATOR$4, ArrayValues);
    if (!proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME$1);
    _iterators[NAME$1] = ArrayValues;
    if (explicit) for (key in es6_array_iterator) if (!proto[key]) _redefine(proto, key, es6_array_iterator[key], true);
  }
}

// https://github.com/tc39/Array.prototype.includes

var $includes = _arrayIncludes(true);

_export(_export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables('includes');

// 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');
var _isRegexp = function (it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
};

// helper for String#{startsWith, endsWith, includes}



var _stringContext = function (that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');
var _failsIsRegexp = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

var INCLUDES = 'includes';

_export(_export.P + _export.F * _failsIsRegexp(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~_stringContext(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

webpackJsonp([1],{/***/"/902":/***/function _(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EmbedCode.vue
//
//
//
//
//
//
//
//
var postscribe=__webpack_require__("5Vgs");/* harmony default export */var EmbedCode={mounted:function mounted(){var embed=this.$slots.default[0].text;postscribe(this.$refs.embed,embed);}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c50150a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmbedCode.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"embed"},[_c('div',{staticClass:"hidden"},[_vm._t("default")],2)]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_EmbedCode=esExports;// CONCATENATED MODULE: ./src/components/EmbedCode.vue
var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=null;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(EmbedCode,components_EmbedCode,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_EmbedCode=__webpack_exports__["default"]=Component.exports;/***/},/***/"/iwA":/***/function iwA(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// EXTERNAL MODULE: ./node_modules/vue-flickity/src/flickity.vue + 2 modules
var flickity=__webpack_require__("6IAB");// EXTERNAL MODULE: ./node_modules/vue-images-loaded/dist/vueimagesloaded.js
var vueimagesloaded=__webpack_require__("iPd/");var vueimagesloaded_default=/*#__PURE__*/__webpack_require__.n(vueimagesloaded);// EXTERNAL MODULE: ./node_modules/scroll-into-view/scrollIntoView.js
var scrollIntoView=__webpack_require__("6J+x");var scrollIntoView_default=/*#__PURE__*/__webpack_require__.n(scrollIntoView);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PaginatedTabs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var PaginatedTabs={components:{Flickity:flickity["a"/* default */]},directives:{imagesLoaded:vueimagesloaded_default.a},props:['tabs','color'],data:function data(){return{activeIndex:0,flickityOptions:{cellSelector:'.carousel-cell',selectedAttraction:0.12,friction:0.75,prevNextButtons:false,pageDots:false,wrapAround:false,draggable:false},activeClass:'text-white border-blue bg-blue',inactiveClass:'text-blue border-white bg-transparent hover:bg-white'};},computed:{canGoBack:function canGoBack(){return this.activeIndex>0;},canGoForward:function canGoForward(){if(this.tabs){return this.activeIndex<this.tabs.length-1;}}},methods:{imagesLoaded:function imagesLoaded(){this.$refs.flickity.resize();},gotoTab:function gotoTab(tab){switch(tab){case'prev':if(this.canGoBack){this.$refs.flickity.previous();this.activeIndex--;}break;case'next':if(this.canGoForward){this.$refs.flickity.next();this.activeIndex++;}break;default:this.$refs.flickity.selectCell(tab);this.activeIndex=tab;break;}if(window.outerWidth<768){scrollIntoView_default()(this.$refs['tab'+this.activeIndex][0],{time:300,ease:function ease(t){return t*t;},align:{topOffset:89,top:0,left:0}});}}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f8898eb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaginatedTabs.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paginated-tabs container relative",class:_vm.color},[_c('div',{staticClass:"w-full overflow-scroll scrolling-touch md:overflow-hidden lg:pl-24"},[_c('div',{staticClass:"flex md:mr-24 lg:mb-6 flex-col md:flex-row md:items-center justify-between md:overflow-hidden md:scrolling-touch"},[_c('ul',{staticClass:"list-reset mr-8 flex uppercase tracking-1px mb-0"},_vm._l(_vm.tabs,function(tab,i){return _c('li',{key:tab.tab,ref:'tab'+i,refInFor:true},[_c('button',{staticClass:"\n            appearance-none\n            whitespace-no-wrap\n            block\n            transition\n            uppercase no-underline\n            h5 px-10 md:px-6 py-2 border\n            focus:outline-none\n            cursor-pointer ",class:[i===_vm.activeIndex?_vm.activeClass:_vm.inactiveClass,i===0?'border-r-0':i===_vm.tabs.length-1?'border-l-0':'border-r-0 border-l-0'],on:{"click":function click($event){_vm.gotoTab(i);}}},[_vm._v(_vm._s(tab.tab))])]);}))])]),_vm._v(" "),_c('flickity',{directives:[{name:"images-loaded",rawName:"v-images-loaded:on.progress",value:_vm.imagesLoaded,expression:"imagesLoaded",arg:"on",modifiers:{"progress":true}}],ref:"flickity",staticClass:"mt-5 relative z-10 outline-none",attrs:{"options":_vm.flickityOptions}},[_c('pagination-arrows',{staticClass:"absolute md:ml-8 z-10 md:pin-t md:pin-r lg:h-full pad-past-image",attrs:{"canGoBack":_vm.canGoBack,"canGoForward":_vm.canGoForward},on:{"handleClick":_vm.gotoTab}}),_vm._v(" "),_vm._l(_vm.tabs,function(tab,index){return _c('div',{key:index},[_c('PaginatedTab',{attrs:{"tab":tab}})],1);})],2)],1);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_PaginatedTabs=esExports;// CONCATENATED MODULE: ./src/components/PaginatedTabs.vue
function injectStyle(ssrContext){__webpack_require__("KYne");}var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(PaginatedTabs,components_PaginatedTabs,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_PaginatedTabs=__webpack_exports__["default"]=Component.exports;/***/},/***/"0JL+":/***/function JL(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'video-play':{width:40,height:40,viewBox:'0 0 40 40',data:'<defs><path pid="0" id="svgicon-video-play-a" d="M245 198v20l16-10z"/></defs><g transform="translate(-231 -188)" _fill="none" fill-rule="evenodd"><circle pid="1" fill-opacity=".8" _fill="#FFF" cx="251" cy="208" r="20"/><use _fill="#19398A" xlink:href="#svgicon-video-play-a"/></g>'}});/***/},/***/"0eYA":/***/function eYA(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'arrow':{width:24,height:24,viewBox:'-0.249 3.818 37.25 18.63',data:'<path d="M 9.061 -5.492 L 27.691 13.138 L 9.061 31.758 L 9.061 -5.492 Z" data-name="Layer 1" id="svgicon-arrow-a" transform="matrix(0, -1, 1, 0, 5.243001, 31.509)"/>'}});/***/},/***/"1ii6":/***/function ii6(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'menu-plus':{width:24,height:24,viewBox:'0 0 24 24',data:'<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M11 0h2v24h-2z"/><path pid="1" d="M0 11h24v2H0z"/></g>'}});/***/},/***/"4h//":/***/function h(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"6IAB":/***/function IAB(module,__webpack_exports__,__webpack_require__){var js=__webpack_require__("kG3H");var js_default=/*#__PURE__*/__webpack_require__.n(js);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-flickity/src/flickity.vue
//
//
//
//
//
//
/* harmony default export */var flickity={props:{options:Object},mounted:function mounted(){this.init();},beforeDestroy:function beforeDestroy(){this.$flickity.destroy();this.$flickity=null;},methods:{/**
     * Initialize a new flickity and emit init event.
     */init:function init(){this.$flickity=new js_default.a(this.$el,this.options);this.$emit('init',this.$flickity);},/**
     * Return the current flickity instance to access directly
     *
     * @return {Flickity}
     */flickity:function flickity(){return this.$flickity;},/**
     * Selecting Slides
     */ /**
     * Select a slide
     *
     * @param {number} index
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */select:function select(index,isWrapped,isInstant){this.$flickity.select(index,isWrapped,isInstant);},/**
     * Change to the next slide
     *
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */next:function next(isWrapped,isInstant){this.$flickity.next(isWrapped,isInstant);},/**
     * Change to the previous slide
     *
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */previous:function previous(isWrapped,isInstant){this.$flickity.previous(isWrapped,isInstant);},/**
     * Select a cell
     *
     * @param {number} value
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */selectCell:function selectCell(value,isWrapped,isInstant){this.$flickity.selectCell(value,isWrapped,isInstant);},/**
     * Sizing and Positioning
     */ /**
     * Trigger a resize event
     */resize:function resize(){this.$flickity.resize();},/**
     * Trigger a reposition event
     */reposition:function reposition(){this.$flickity.reposition();},/**
     * Adding and removing cells
     */ /**
     * Prepend elements to flickity
     *
     * @param {array|HTMLElement|NodeList} elements
     */prepend:function prepend(elements){this.$flickity.prepend(elements);},/**
     * Append elements to flickity
     *
     * @param {array|HTMLElement|NodeList} elements
     */append:function append(elements){this.$flickity.append(elements);},/**
     * Insert elements at a given index
     *
     * @param {array|HTMLElement|NodeList} elements
     * @param {number} index
     */insert:function insert(elements,index){this.$flickity.insert(elements,index);},/**
     * Remove elements from flickity
     *
     * @param {array|HTMLElement|NodeList} elements
     */remove:function remove(elements){this.$flickity.remove(elements);},/**
     * Player
     */ /**
     * Trigger a playPlayer event
     */playPlayer:function playPlayer(){this.$flickity.playPlayer();},/**
     * Trigger a stopPlayer event
     */stopPlayer:function stopPlayer(){this.$flickity.stopPlayer();},/**
     * Trigger a pausePlayer event
     */pausePlayer:function pausePlayer(){this.$flickity.pausePlayer();},/**
     * Trigger a unpausePlayer event
     */unpausePlayer:function unpausePlayer(){this.$flickity.unpausePlayer();},/**
     * Trigger a rerender event
     */rerender:function rerender(){this.$flickity.destroy();this.init();},/**
     * Utilities
     */ /**
     * Destroy the flickity instance
     */destroy:function destroy(){this.$flickity.destroy();},/**
     * Trigger a rerender event
     */reloadCells:function reloadCells(){this.$flickity.reloadCells();},/**
     * Get the cell elements
     *
     * @return {array}
     */getCellElements:function getCellElements(){return this.$flickity.getCellElements();},/**
     * Return flickity data
     *
     * @return {Flickity}
     */data:function data(){return js_default.a.data(this.$el);},/**
     * Events
     */ /**
     * Attach an event
     *
     * @param {string} eventName
     * @param {function} listener
     */on:function on(eventName,listener){this.$flickity.on(eventName,listener);},/**
     * Remove an event
     *
     * @param {string} eventName
     * @param {function} listener
     */off:function off(eventName,listener){this.$flickity.off(eventName,listener);},/**
     * Attach an event once
     *
     * @param {string} eventName
     * @param {function} listener
     */once:function once(eventName,listener){this.$flickity.once(eventName,listener);},/**
     * Properties
     */ /**
     * Return the selected element
     *
     * @return {HTMLElement}
     */selectedElement:function selectedElement(){return this.$flickity.selectedElement;},/**
     * Return the selected elements
     *
     * @return {array}
     */selectedElements:function selectedElements(){return this.$flickity.selectedElements;},/**
     * Return the selected index
     *
     * @return {number}
     */selectedIndex:function selectedIndex(){return this.$flickity.selectedIndex;},/**
     * Return the cells
     *
     * @return {array}
     */cells:function cells(){return this.$flickity.cells;},/**
     * Return the slides
     *
     * @return {array}
     */slides:function slides(){return this.$flickity.slides;},/**
     * Disable dragging of slider
     */disableDrag:function disableDrag(){this.$flickity.options.draggable=false;this.$flickity.updateDraggable();},/**
     * Enable dragging of slider
     */enableDrag:function enableDrag(){this.$flickity.options.draggable=true;this.$flickity.updateDraggable();}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e501e806","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-flickity/src/flickity.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var src_flickity=esExports;// CONCATENATED MODULE: ./node_modules/vue-flickity/src/flickity.vue
function injectStyle(ssrContext){__webpack_require__("T+gj");}var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(flickity,src_flickity,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var vue_flickity_src_flickity=__webpack_exports__["a"]=Component.exports;/***/},/***/"6QXh":/***/function QXh(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HoverSquare.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var HoverSquare={props:{id:{required:false},groupId:{required:false},lastName:{required:false},heading:{required:true,type:String},subheading:{type:String},body:{required:false},footer:{required:false},target:{required:false},bgImage:{required:false},meta:{required:false},isLink:{default:true,required:false}},data:function data(){return{reveal:false};},methods:{mouseover:function mouseover(e){if(!this.$refs.hoverSquare.contains(e.relatedTarget)){this.reveal=true;}},mouseout:function mouseout(e){if(!this.$refs.hoverSquare.contains(e.relatedTarget)){this.reveal=false;}},clickHandler:function clickHandler(e){if(!this.isLink){e.preventDefault();}}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c537a40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HoverSquare.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"hoverSquare",staticClass:"aspect-ratio-square transition relative block overflow-hidden",class:{'cursor-default':!_vm.isLink},staticStyle:{"min-height":"288px","min-width":"288px"},attrs:{"href":_vm.isLink?_vm.footer.url:'#',"target":_vm.isLink&&'_blank'},on:{"mouseover":_vm.mouseover,"mouseout":_vm.mouseout,"click":_vm.clickHandler}},[_c('img',{staticClass:"block w-full h-full absolute pin transition object-cover",attrs:{"src":_vm.bgImage,"height":"288","width":"288","alt":""}}),_vm._v(" "),_c('article',{staticClass:"absolute z-20 pin flex flex-col justify-between",class:{'revealed':_vm.reveal&&_vm.isLink}},[_c('div',{staticClass:"relative z-10 w-full pt-6 px-4 transition",class:[_vm.reveal?'opacity-100':'opacity-0']},[_c('h1',{staticClass:"uppercase font-bold text-sm leading-tight"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_vm.subheading?_c('h2',{staticClass:"h5 font-bold leading-tight mt-2"},[_vm._v(_vm._s(_vm.subheading))]):_vm._e()]),_vm._v(" "),_vm.footer&&_vm.isLink?_c('div',{staticClass:"relative z-20 px-4 py-2 bg-blue"},[_c('span',{staticClass:"cursor-pointer inline-block link-with-arrow",staticStyle:{"text-decoration":"none"}},[_c('span',{domProps:{"textContent":_vm._s(_vm.reveal?'Learn More':_vm.heading)}}),_vm._v(" "),_c('icon',{staticClass:"fill-current ml-1",attrs:{"name":"arrow","dir":"right","width":"12","height":"12"}})],1)]):_vm._e()])]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_HoverSquare=esExports;// CONCATENATED MODULE: ./src/components/HoverSquare.vue
function injectStyle(ssrContext){__webpack_require__("pC1k");}var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-3c537a40";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(HoverSquare,components_HoverSquare,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_HoverSquare=__webpack_exports__["default"]=Component.exports;/***/},/***/"6oFW":/***/function oFW(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'footer-facebook':{width:21,height:21,viewBox:'0 0 21 21',data:'<path pid="0" d="M0 10.491c0-1.419.276-2.778.83-4.078.552-1.3 1.3-2.413 2.24-3.339.942-.926 2.062-1.673 3.362-2.24a9.82 9.82 0 0 1 4.079-.83 10.87 10.87 0 0 1 4.079.83c1.3.537 2.413 1.284 3.34 2.24.925.956 1.672 2.07 2.24 3.339.568 1.27.844 2.63.83 4.078a10.634 10.634 0 0 1-3.07 7.44 9.958 9.958 0 0 1-3.34 2.241c-1.27.523-2.63.8-4.08.83a9.199 9.199 0 0 1-4.078-.83 12.468 12.468 0 0 1-3.362-2.24C2.1 17.02 1.352 15.898.83 14.57.305 13.24.03 11.88 0 10.49zm7.866 0h1.166v5.67h2.353v-5.67h1.569l.201-1.95h-1.77v-.985c0-.299.045-.5.134-.605.09-.105.307-.165.65-.18h.964v-1.95h-1.569c-.911 0-1.561.218-1.95.65-.388.434-.582 1.069-.582 1.906v1.165H7.866v1.95z" _fill="#FFF" fill-rule="evenodd"/>'}});/***/},/***/"7UW2":/***/function UW2(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'gallery-arrow':{width:69,height:39,viewBox:'0 0 69 39',data:'<path pid="0" _fill="#19398A" fill-rule="nonzero" d="M34.572.912l.16.176 33.5 33.492-3.828 3.828L34.572 8.577 4.74 38.408.912 34.58 34.404 1.088z"/>'}});/***/},/***/"91E/":/***/function E(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// EXTERNAL MODULE: ./node_modules/vue-flickity/src/flickity.vue + 2 modules
var flickity=__webpack_require__("6IAB");// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ImageSlider.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var ImageSlider={components:{Flickity:flickity["a"/* default */]},props:['images'],data:function data(){return{activeIndex:0,flickityOptions:{selectedAttraction:0.15,friction:0.7,cellAlign:'left',prevNextButtons:false,pageDots:false,wrapAround:false,draggable:false,groupCells:true}};},created:function created(){var _this=this;var keyHandler=function keyHandler(e){if(e.key==='ArrowLeft'){_this.goto('prev');}if(e.key==='ArrowRight'){_this.goto('next');}};document.addEventListener('keydown',keyHandler);this.$once('hook:destroyed',function(){document.removeEventListener('keydown',keyHandler);});},computed:{canGoBack:function canGoBack(){return this.activeIndex>0;},canGoForward:function canGoForward(){return this.activeIndex<this.images.length-1;}},methods:{goto:function goto(direction){switch(direction){case'prev':if(this.canGoBack){this.$refs.flickity.previous();this.activeIndex--;}break;case'next':if(this.canGoForward){this.$refs.flickity.next();this.activeIndex++;}break;}}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02814232","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageSlider.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"mx-auto image-slider relative overflow-visible"},[_c('flickity',{ref:"flickity",attrs:{"options":_vm.flickityOptions}},_vm._l(_vm.images,function(image){return _c('div',{key:image,staticClass:"carousel-cell relative w-full mx-10"},[_c('div',{staticClass:"aspect-ratio-4/3 md:aspect-ratio-6/4 lg:aspect-ratio-hero pin bg-grey-lighter spinner"}),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:image,expression:"image"}],staticClass:"absolute pin w-full h-full object-cover block",attrs:{"width":"1200","height":"720","alt":""}})]);}))],1),_vm._v(" "),_c('pagination-arrows',{staticClass:"pad-past-image z-10 pt-4\n    md:absolute md:h-full md:pb-1 md:flex-col-reverse md:flex-wrap md:justify-center\n    md:pin-t md:pin-r xxl:-mr-20 md:px-workHero md:bg-white",attrs:{"canGoBack":_vm.canGoBack,"canGoForward":_vm.canGoForward},on:{"handleClick":_vm.goto}})],1);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_ImageSlider=esExports;// CONCATENATED MODULE: ./src/components/ImageSlider.vue
function injectStyle(ssrContext){__webpack_require__("hKbm");}var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(ImageSlider,components_ImageSlider,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_ImageSlider=__webpack_exports__["default"]=Component.exports;/***/},/***/"9x8b":/***/function x8b(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'quote-marks':{width:53,height:43,viewBox:'0 0 92.92 69.92',data:'<path d="M13.86 49.14c.31-6.61 4.72-10.08 11.34-10.08 7.87 0 13.86 5.36 13.86 14.81 0 8.82-6.93 16.06-17.32 16.06C6.93 69.92 0 58.27 0 45.67 0 26.78 11.65 10.08 30.24 0l5.67 9.77C20.79 16.7 12.6 30.56 12.6 43.15c0 2.21.31 4.1 1.26 5.99Zm53.86 0c.32-6.61 4.72-10.08 11.34-10.08 7.87 0 13.86 5.36 13.86 14.81 0 8.82-6.93 16.06-17.33 16.06-14.8 0-21.73-11.65-21.73-24.25 0-18.9 11.65-35.59 30.24-45.67l5.67 9.77c-15.12 6.93-23.31 20.79-23.31 33.38 0 2.21.31 4.1 1.26 5.99Z" data-name="Layer 1"/><'}});/***/},/***/"Aww3":/***/function Aww3(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PaginationArrows.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var PaginationArrows={props:['canGoForward','canGoBack'],methods:{handleClick:function handleClick(direction){this.$emit('handleClick',direction);}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e48a1de4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaginationArrows.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-reset flex lg:flex-col lg:flex-wrap"},[_c('li',{staticClass:"lg:w-full order-2 lg:order-1"},[_c('button',{staticClass:"cursor-pointer  transition focus:outline-none",class:[{'hover:grow':_vm.canGoForward},{'cursor-not-allowed':!_vm.canGoForward}],on:{"click":function click($event){_vm.handleClick('next');}}},[_c('div',[_c('icon',{staticClass:"stroke-current text-blue transition",class:{'fill-current':_vm.canGoForward},attrs:{"name":"arrow","dir":"right","width":"24","height":"24"}})],1)])]),_vm._v(" "),_c('li',{staticClass:"mr-3 md:mr-1 lg:mr-3 lg:mt-2 order-1 lg:order-2"},[_c('button',{staticClass:"cursor-pointer transition focus:outline-none",class:[{'hover:grow':_vm.canGoBack},{'cursor-not-allowed':!_vm.canGoBack}],on:{"click":function click($event){_vm.handleClick('prev');}}},[_c('div',[_c('icon',{staticClass:"stroke-current text-blue transition",class:{'fill-current':_vm.canGoBack},attrs:{"name":"arrow","dir":"left","width":"24","height":"24"}})],1)])])]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_PaginationArrows=esExports;// CONCATENATED MODULE: ./src/components/PaginationArrows.vue
var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=null;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(PaginationArrows,components_PaginationArrows,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_PaginationArrows=__webpack_exports__["default"]=Component.exports;/***/},/***/"CgCn":/***/function CgCn(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var VideoModal={data:function data(){return{embedUrl:false};},created:function created(){var _this=this;this.$eventBus.$on('openVideoModal',function(embedUrl){if(embedUrl.includes('youtube.com/embed')){_this.embedUrl='https:'+embedUrl+'?autoplay=1&rel=0';}else{_this.embedUrl=embedUrl;}});var escapeHandler=function escapeHandler(e){if(e.key==='Escape'){_this.close();}};document.addEventListener('keydown',escapeHandler);this.$once('hook:destroyed',function(){document.removeEventListener('keydown',escapeHandler);});},methods:{close:function close(){this.embedUrl=false;}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4780d77a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoModal.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade-fixed"}},[_vm.embedUrl?_c('div',[_c('div',{staticClass:"pin z-50 bg-blue-dark-95 fixed flex items-center justify-center",on:{"click":function click($event){$event.stopPropagation();return _vm.close($event);}}},[_c('button',{staticClass:"w-8 h-8 md:w-12 md:h-12 p-2 absolute pin-t pin-r m-6 md:m-10 transition hover:grow opacity-75 hover:opacity-100",on:{"click":function click($event){$event.stopPropagation();return _vm.close($event);}}},[_c('icon',{staticClass:"fill-current text-white",attrs:{"name":"close","width":"100%","height":"100%"}})],1),_vm._v(" "),_c('div',{staticClass:"relative m-4 w-full md:w-3/4"},[_c('div',{staticClass:"absolute shadow-lg spinner bg-black-actual aspect-ratio-16/9"}),_vm._v(" "),_c('iframe',{staticClass:"absolute pin block w-full h-full",attrs:{"src":_vm.embedUrl,"frameborder":"0","autoplay":"","allow":"autoplay; encrypted-media","allowfullscreen":""}})])])]):_vm._e()])],1);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_VideoModal=esExports;// CONCATENATED MODULE: ./src/components/VideoModal.vue
function injectStyle(ssrContext){__webpack_require__("RKgC");}var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-4780d77a";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(VideoModal,components_VideoModal,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_VideoModal=__webpack_exports__["default"]=Component.exports;/***/},/***/"Cv/O":/***/function CvO(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PaginatedTab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var PaginatedTab={props:['tab'],data:function data(){return{active:0};},computed:{bgImg:function bgImg(){if(this.tab.featured.length){return'background-image:url('+this.tab.featured[this.active].image+')';}else{return'background-image:url('+this.tab.img;}},linkUrl:function linkUrl(){if(this.tab.featured.length){return this.tab.featured[this.active].url;}}},methods:{setActiveProj:function setActiveProj(projIndex){this.active=projIndex;}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d56de7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaginatedTab.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-cell flex flex-col lg:flex-row w-full"},[_c('div',{staticClass:"lg:p-0 mb-20 md:mb-8 lg:w-3/5 relative"},[_c('img',{staticClass:"w-full block",attrs:{"src":_vm.tab.img,"alt":""}}),_vm._v(" "),_vm.tab.video?_c('button',{staticClass:"absolute w-full pin flex items-center justify-center hover:grow-child opacity-75 hover:opacity-100 transition",on:{"click":function click($event){_vm.$eventBus.$emit('openVideoModal',_vm.tab.video);}}},[_c('icon',{staticClass:"fill-current transition",attrs:{"original":true,"name":"video-play","width":"80","height":"80"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"md:pl-24 lg:pl-16 lg:w-2/5 lg:px-16"},[_c('h2',{staticClass:"h2 text-blue"},[_vm._v(_vm._s(_vm.tab.heading))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.tab.body)}}),_vm._v(" "),_vm.tab.featured.length?_c('div',{staticClass:"mt-6"},[_c('h3',{staticClass:"h3 text-24 text-blue"},[_vm._v("Featured "+_vm._s(_vm.tab.heading)+" Projects")]),_vm._v(" "),_c('ul',{staticClass:"list-reset mb-3"},_vm._l(_vm.tab.featured,function(proj,index){return _c('li',{key:index,staticClass:"leading-none mt-3"},[_c('button',{staticClass:"group cursor-pointer inline-block text-grey-darker uppercase no-underline tracking-1px text-lg inline-flex text-left items-center focus:outline-none transition",class:{'text-blue':_vm.active==index},on:{"click":function click($event){_vm.setActiveProj(index);}}},[_c('icon',{staticClass:"fill-current opacity-0 group-hover:opacity-100 absolute text-blue -ml-5 -mt-px transition",attrs:{"name":"arrow","dir":"right","width":"12","height":"12"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(proj.title))])],1)]);}))]):_vm._e(),_vm._v(" "),_vm.tab.linkField.text?_c('link-with-arrow',{staticClass:"mt-4",attrs:{"href":_vm.tab.linkField.url}},[_vm._v("\n      "+_vm._s(_vm.tab.linkField.text)+"\n    ")]):_vm._e(),_vm._v(" "),_vm.linkUrl?_c('link-with-arrow',{staticClass:"mt-4",attrs:{"href":_vm.linkUrl}},[_vm._v("\n        View Project\n    ")]):_vm._e()],1)]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_PaginatedTab=esExports;// CONCATENATED MODULE: ./src/components/PaginatedTab.vue
function injectStyle(ssrContext){__webpack_require__("rxHZ");}var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-3d56de7c";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(PaginatedTab,components_PaginatedTab,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_PaginatedTab=__webpack_exports__["default"]=Component.exports;/***/},/***/"DDte":/***/function DDte(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'marker':{width:12,height:15,viewBox:'0 0 12 15',data:'<path pid="0" d="M10.243 10.243L6 14.485l-4.243-4.242a6 6 0 1 1 8.486 0zM4.586 7.414a2 2 0 1 0 2.828-2.828 2 2 0 0 0-2.828 2.828z" _fill="#19398A" fill-rule="evenodd"/>'}});/***/},/***/"EjQ4":/***/function EjQ4(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MainNav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var MainNav={props:['nav'],methods:{isActive:function isActive(node){if(node.active){var activeSliblings=this.nav.filter(function(n){return n.active&&n.url!==node.url;});var activeChildren=node.subNav.filter(function(n){return n.active&&n.url!==node.url;});if(activeSliblings.length){return activeChildren.length;}}return node.active;}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22d74d8d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainNav.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{},[_c('ul',{staticClass:"flex list-reset h-full justify-center items-stretch"},_vm._l(_vm.nav,function(node,index){return _c('li',{key:index,staticClass:"group pt-2 pb-4 xl:py-5 flex items-center relative",class:{'mr-4 md:mr-8 xl:mr-8':index<_vm.nav.length-1}},[node.subNav.length?_c('span',{staticClass:"z-10 transition opacity-0 group-hover:opacity-100 block absolute pin-b w-full",staticStyle:{"height":"5px"}},[_c('span',{staticClass:"triangle-after-nav w-full bg-orange block",staticStyle:{"margin-left":"11px"}})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"mainnav__top-a font-bold text-blue text-sm lg2:text-base pb-1 no-underline -ml-2 -mr-2 px-2 pt-3 h-full flex items-center",attrs:{"href":node.url}},[_c('span',{staticClass:"transition border-white z-10 border-b-2",class:{'border-orange':_vm.isActive(node)}},[_vm._v(_vm._s(node.title))])]),_vm._v(" "),node.subNav.length?_c('ul',{staticClass:"pointer-events-none group-hover:pointer-events-auto transition opacity-0 group-hover:opacity-100 group-hover:block absolute list-reset bg-blue pin-b text-sm shadow leading-loose",staticStyle:{"transform":"translateY(100%)"}},_vm._l(node.subNav,function(sub){return _c('li',{key:sub.title},[_c('a',{staticClass:"text-white whitespace-no-wrap font-bold inline-block w-full no-underline py-2 px-4 hover:bg-grey hover:text-blue",attrs:{"href":sub.url}},[_vm._v(_vm._s(sub.title))])]);})):_vm._e()]);}))]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_MainNav=esExports;// CONCATENATED MODULE: ./src/components/MainNav.vue
function injectStyle(ssrContext){__webpack_require__("4h//");}var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-22d74d8d";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(MainNav,components_MainNav,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_MainNav=__webpack_exports__["default"]=Component.exports;/***/},/***/"Gd+1":/***/function Gd1(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys=__webpack_require__("fZjL");var keys_default=/*#__PURE__*/__webpack_require__.n(keys);// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash=__webpack_require__("M4fF");var lodash_default=/*#__PURE__*/__webpack_require__.n(lodash);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FilterSquares.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var FilterSquares={props:['sections','filters','squares','page'],data:function data(){return{activeFilters:false,scrollToOnChange:false};},computed:{cleanActiveFilters:function cleanActiveFilters(){return lodash_default.a.omitBy(this.activeFilters,function(o){return o==='all';});},showHeadings:function showHeadings(){return this.page!=='team'||keys_default()(this.cleanActiveFilters).length===0;}},methods:{filteredSquares:function filteredSquares(additionalFilterK,additionalFilterV){// Clean start
var prepSquares=this.squares;// If on team and no fiters then group
if(this.showHeadings){prepSquares=prepSquares.filter(function(square){return square.meta[additionalFilterK]===additionalFilterV;});}else{prepSquares=lodash_default.a.sortBy(prepSquares,['lastName']);}// Filter squares by activeFilters
lodash_default.a.forEach(this.cleanActiveFilters,function(filterK,filterV){prepSquares=prepSquares.filter(function(square){if(Array.isArray(square.meta[filterV])){// Check arrays contain value
return square.meta[filterV].includes(filterK);}else{// Check others are value
return square.meta[filterV]===filterK;}});});return prepSquares;}},watch:{activeFilters:{handler:function handler(){var _this=this;if(this.scrollToOnChange){this.$scrollTo(this.$refs.filterSquares,500,{offset:-130});}else{this.scrollToOnChange=true;}var qs=keys_default()(this.activeFilters).map(function(key){return key+'='+_this.activeFilters[key];}).join('&');history.replaceState(null,null,'?'+qs);},deep:true}},mounted:function mounted(){var urlParams=new URLSearchParams(window.location.search);var filters={};lodash_default.a.forEach(this.filters,function(item){if(item.type==='select'){if(urlParams.get(item.key)===null){filters[item.key]='all';}else{filters[item.key]=urlParams.get(item.key);}}else if(item.type==='checkbox'){if(urlParams.get(item.key)==='true'){filters[item.key]=true;}}});this.activeFilters=filters;}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7f67f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterSquares.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"filterSquares",staticClass:"container mb-16",attrs:{"data-component":"filter-squares"}},[_vm.filters?_c('div',{staticClass:"md:grid grid-columns-12 -mt-4 pb-16 grid-gap-1"},[_vm._m(0),_vm._v(" "),_vm._l(_vm.filters,function(filter){return _c('div',{key:filter.name,staticClass:"md:col-span-6 lg:col-span-3 mb-4 md:mb-0"},[filter.type=='select'?_c('div',{},[_c('h5',{staticClass:"h5 text-blue"},[_vm._v(_vm._s(filter.name))]),_vm._v(" "),_c('div',{staticClass:"select triangle-after-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:_vm.activeFilters[filter.key],expression:"activeFilters[filter.key]"}],staticClass:"appearance-none border bg-white rounded-none p-4 text-base text-grey-darker w-full hover:border-blue transition focus:outline-none",on:{"change":function change($event){var $$selectedVal=Array.prototype.filter.call($event.target.options,function(o){return o.selected;}).map(function(o){var val="_value"in o?o._value:o.value;return val;});_vm.$set(_vm.activeFilters,filter.key,$event.target.multiple?$$selectedVal:$$selectedVal[0]);}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(filter.all))]),_vm._v(" "),_vm._l(filter.options,function(opt){return _c('option',{key:opt.value,domProps:{"value":opt.value}},[_vm._v(_vm._s(opt.title))]);})],2)])]):_vm._e(),_vm._v(" "),filter.type=='checkbox'?_c('div',{},[_c('div',{staticClass:"flex items-center justify-center pt-10"},[_c('label',{staticClass:"h5 text-blue flex items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:_vm.activeFilters[filter.key],expression:"activeFilters[filter.key]"}],staticClass:"mr-3",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.activeFilters[filter.key])?_vm._i(_vm.activeFilters[filter.key],null)>-1:_vm.activeFilters[filter.key]},on:{"change":function change($event){var $$a=_vm.activeFilters[filter.key],$$el=$event.target,$$c=$$el.checked?true:false;if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&_vm.$set(_vm.activeFilters,filter.key,$$a.concat([$$v]));}else{$$i>-1&&_vm.$set(_vm.activeFilters,filter.key,$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.$set(_vm.activeFilters,filter.key,$$c);}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(filter.name))])])])]):_vm._e()]);})],2):_vm._e(),_vm._v(" "),_vm._l(_vm.sections,function(section,idx){return _vm.showHeadings===true||idx==0?_c('div',{key:section.name,staticClass:"clearfix"},[section.name.length&&_vm.showHeadings?_c('h1',{staticClass:"h1 text-blue"},[_vm._v(_vm._s(section.name))]):_vm._e(),_vm._v(" "),_vm.showHeadings?_c('transition',{attrs:{"name":"square"}},[_vm.filteredSquares(section.param.key,section.param.value).length===0?_c('p',{staticClass:"h5"},[_vm._v("\n        No "+_vm._s(section.name)+"\n      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-16 grid grid-columns-12 grid-gap-1"},_vm._l(_vm.filteredSquares(section.param.key,section.param.value,section.orderByLastName),function(item){return _c('hover-square',{key:item.id,staticClass:"\n          float-left\n          col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3\n          mb-6 md:mb-0\n        ",attrs:{"id":item.id,"lastName":item.lastName,"groupId":item.groupId,"heading":item.heading,"bgImage":item.bgImage,"subheading":item.subheading,"body":item.body,"footer":item.footer,"meta":item.meta,"isLink":section.linkToBio}});}))],1):_vm._e();})],2);};var staticRenderFns=[function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:col-span-6 lg:col-span-3 lg:row-span-2 pt-5"},[_c('h2',{staticClass:"h2 text-blue"},[_vm._v("Filter By")])]);}];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_FilterSquares=esExports;// CONCATENATED MODULE: ./src/components/FilterSquares.vue
var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=null;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(FilterSquares,components_FilterSquares,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_FilterSquares=__webpack_exports__["default"]=Component.exports;/***/},/***/"JyMW":/***/function JyMW(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileNav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var MobileNav={props:['nav'],data:function data(){return{openIndex:-1};},methods:{handleClick:function handleClick(index){if(this.openIndex===index){this.openIndex=-1;}else{this.openIndex=index;}}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ddd0111","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileNav.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"z-20 bg-blue flex items-center justify-center"},[_c('div',{staticClass:"container overflow-scroll scrolling-touch py-10 w-full",staticStyle:{"height":"calc(100vh - 72px)"}},[_c('ul',{staticClass:"list-reset"},_vm._l(_vm.nav,function(node,index){return _c('li',{key:index,staticClass:"mb-4"},[_c('div',{staticClass:"flex justify-between pr-2"},[_c('a',{staticClass:"text-white no-underline text-24",attrs:{"href":node.url}},[_c('span',{staticClass:"leading-tight border-b-2 hover:border-white transition",class:[{'border-orange':node.active},{'border-blue':!node.active}]},[_vm._v("\n                "+_vm._s(node.title)+"\n              ")])]),_vm._v(" "),node.subNav.length?_c('button',{staticClass:"cursor-pointer block focus:outline-none relative w-6 h-6",on:{"click":function click($event){_vm.handleClick(index);}}},[_c('span',{staticClass:"bg-white block absolute",staticStyle:{"height":"2px","width":"24px","top":"50%","margin-top":"-2px"}}),_vm._v(" "),_c('span',{staticClass:"bg-white block absolute transition-fast",class:{'skew-closed':index==_vm.openIndex},staticStyle:{"height":"24px","width":"2px","top":"0","left":"50%","margin-left":"-1px"}})]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show-slide",rawName:"v-show-slide",value:node.subNav.length&&index==_vm.openIndex,expression:"node.subNav.length && index == openIndex"}]},[_c('ul',{staticClass:"pt-6 pb-2 list-reset ml-6"},_vm._l(node.subNav,function(sub){return _c('li',{key:sub.title,staticClass:"mb-4"},[_c('a',{staticClass:"text-white text-lg no-underline border-b border-blue hover:border-white transition",attrs:{"href":sub.url}},[_vm._v("\n                  "+_vm._s(sub.title)+"\n                ")])]);}))])]);}))])])]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_MobileNav=esExports;// CONCATENATED MODULE: ./src/components/MobileNav.vue
var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=null;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(MobileNav,components_MobileNav,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_MobileNav=__webpack_exports__["default"]=Component.exports;/***/},/***/"KYne":/***/function KYne(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"MVxg":/***/function MVxg(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'burger':{width:20,height:16,viewBox:'0 0 20 16',data:'<defs><path pid="0" d="M0 2V0h20v2H0zm0 7V7h20v2H0zm0 7v-2h20v2H0z" id="svgicon-burger-a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon-burger-b" _fill="#fff"><use xlink:href="#svgicon-burger-a"/></mask><use _fill="#FFF" fill-rule="nonzero" xlink:href="#svgicon-burger-a"/><g mask="url(#svgicon-burger-b)" _fill="#FFF"><path pid="1" d="M-398-406h800v800h-800z"/></g></g>'}});/***/},/***/"NHnr":/***/function NHnr(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from=__webpack_require__("c/Tr");var from_default=/*#__PURE__*/__webpack_require__.n(from);// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm=__webpack_require__("7+uW");// EXTERNAL MODULE: ./src/app.scss
var app=__webpack_require__("h5AK");var app_default=/*#__PURE__*/__webpack_require__.n(app);// EXTERNAL MODULE: ./src/icons/index.js
var icons=__webpack_require__("Q7M0");var icons_default=/*#__PURE__*/__webpack_require__.n(icons);// EXTERNAL MODULE: ./tailwind.js
var tailwind=__webpack_require__("vRaU");var tailwind_default=/*#__PURE__*/__webpack_require__.n(tailwind);// EXTERNAL MODULE: ./node_modules/vueinview/dist/vue-inview.min.js
var vue_inview_min=__webpack_require__("am+L");var vue_inview_min_default=/*#__PURE__*/__webpack_require__.n(vue_inview_min);// EXTERNAL MODULE: ./node_modules/vue-countup-v2/dist/vue-countup.js
var vue_countup=__webpack_require__("iXLo");var vue_countup_default=/*#__PURE__*/__webpack_require__.n(vue_countup);// EXTERNAL MODULE: ./node_modules/vue-svgicon/dist/index.js
var dist=__webpack_require__("0QuU");var dist_default=/*#__PURE__*/__webpack_require__.n(dist);// EXTERNAL MODULE: ./node_modules/v-show-slide/dist/v-show-slide.esm.js
var v_show_slide_esm=__webpack_require__("WZAv");// EXTERNAL MODULE: ./node_modules/vue-mq/dist/vue-mq.es.js
var vue_mq_es=__webpack_require__("iKms");// CONCATENATED MODULE: ./src/components.js
var requireComponent=__webpack_require__("vaql");requireComponent.keys().forEach(function(fileName){// Get component config
var componentConfig=requireComponent(fileName);var cleanFileName=fileName.replace(/^\.\/(.*)\.\w+$/,'$1');// Register component globally
vue_esm["default"].component(cleanFileName,// Look for the component options on `.default`, which will
// exist if the component was exported with `export default`,
// otherwise fall back to module's root.
componentConfig.default||componentConfig);});// CONCATENATED MODULE: ./node_modules/v-img/dist/v-img.mjs
!function(){if("undefined"!=typeof document){var e=document.head||document.getElementsByTagName("head")[0],t=document.createElement("style"),n=" *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { z-index: 9999; height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, 0.7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7], .footer-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, 0.3); height: 50px; z-index: 9999; display: flex; align-items: center; } .header-v-img[data-v-5928e1c7] { justify-content: space-between; } .footer-v-img[data-v-5928e1c7] { bottom: 0; justify-content: center; height: 70px; /* scrolling thumbnails on mobile */ overflow-x: auto; } .footer-v-img img[data-v-5928e1c7] { width: 60px; height: 60px; cursor: pointer; -webkit-transition: transform 0.2s ease-out; transition: transform 0.2s ease-out; object-fit: cover; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .footer-v-img img.is-selected[data-v-5928e1c7] { transform: scale(1.1); } .footer-v-img img[data-v-5928e1c7]:not(:last-child) { margin-right: 7px; } .title-v-img[data-v-5928e1c7] { font-family: 'Avenir', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; color: white; text-align: center; max-height: 100%; overflow: auto; } .count-v-img[data-v-5928e1c7], .buttons-v-img[data-v-5928e1c7] { width: 80px; font-family: 'Avenir', Helvetica, Arial, sans-serif; } .count-v-img[data-v-5928e1c7] { font-size: 15px; color: white; margin-left: 10px; } .buttons-v-img[data-v-5928e1c7] { margin-right: 10px; text-align: right; } .buttons-v-img span path[data-v-5928e1c7] { fill: #e5e6eb; -webkit-transition: fill 0.4s ease-in-out; transition: fill 0.4s ease-in-out; } .buttons-v-img span[data-v-5928e1c7] { cursor: pointer; color: #e5e6eb; font-size: 30px; -webkit-transition: color 0.4s ease-in-out; transition: color 0.4s ease-in-out; text-decoration: none; text-align: center; } .buttons-v-img span[data-v-5928e1c7]:not(:last-child) { margin-right: 8px; } .buttons-v-img span svg[data-v-5928e1c7] { height: 20px; width: 15px; } .buttons-v-img span:hover svg path[data-v-5928e1c7] { fill: white; } .buttons-v-img span[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: 'Avenir', Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, 0.3); z-index: 1000; opacity: 0.3; -webkit-transition: opacity 0.3s ease-in-out; transition: opacity 0.3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity 0.3s ease-in-out; transition: opacity 0.3s ease-in-out; } ";t.type="text/css",t.styleSheet?t.styleSheet.cssText=n:t.appendChild(document.createTextNode(n)),e.appendChild(t);}}();var ImgScreen={render:function render(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.closed?e._e():n("div",{staticClass:"fullscreen-v-img",on:{click:function click(t){if(t.target!==t.currentTarget)return null;e.close(t);}}},[n("div",{staticClass:"header-v-img"},[n("span",{staticClass:"count-v-img"},[e.images.length>1?n("span",[e._v(e._s(e.currentImageIndex+1)+"/"+e._s(e.images.length)+" ")]):e._e()]),n("span",{staticClass:"title-v-img"},[e._v(e._s(e.titles[e.currentImageIndex]))]),n("div",{staticClass:"buttons-v-img"},[e.sourceButtons[e.currentImageIndex]?n("span",[n("a",{attrs:{href:e.images[e.currentImageIndex],target:"_blank"}},[n("svg",{staticStyle:{"enable-background":"new 0 0 475.078 475.077"},attrs:{xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",version:"1.1",id:"Capa_1",x:"0px",y:"0px",width:"512px",height:"512px",viewBox:"0 0 475.078 475.077","xml:space":"preserve"}},[n("path",{attrs:{d:"M467.083,318.627c-5.324-5.328-11.8-7.994-19.41-7.994H315.195l-38.828,38.827c-11.04,10.657-23.982,15.988-38.828,15.988    c-14.843,0-27.789-5.324-38.828-15.988l-38.543-38.827H27.408c-7.612,0-14.083,2.669-19.414,7.994    C2.664,323.955,0,330.427,0,338.044v91.358c0,7.614,2.664,14.085,7.994,19.414c5.33,5.328,11.801,7.99,19.414,7.99h420.266    c7.61,0,14.086-2.662,19.41-7.99c5.332-5.329,7.994-11.8,7.994-19.414v-91.358C475.078,330.427,472.416,323.955,467.083,318.627z     M360.025,414.841c-3.621,3.617-7.905,5.424-12.854,5.424s-9.227-1.807-12.847-5.424c-3.614-3.617-5.421-7.898-5.421-12.844    c0-4.948,1.807-9.236,5.421-12.847c3.62-3.62,7.898-5.431,12.847-5.431s9.232,1.811,12.854,5.431    c3.613,3.61,5.421,7.898,5.421,12.847C365.446,406.942,363.638,411.224,360.025,414.841z M433.109,414.841    c-3.614,3.617-7.898,5.424-12.848,5.424c-4.948,0-9.229-1.807-12.847-5.424c-3.613-3.617-5.42-7.898-5.42-12.844    c0-4.948,1.807-9.236,5.42-12.847c3.617-3.62,7.898-5.431,12.847-5.431c4.949,0,9.233,1.811,12.848,5.431    c3.617,3.61,5.427,7.898,5.427,12.847C438.536,406.942,436.729,411.224,433.109,414.841z",fill:"#FFFFFF"}}),n("path",{attrs:{d:"M224.692,323.479c3.428,3.613,7.71,5.421,12.847,5.421c5.141,0,9.418-1.808,12.847-5.421l127.907-127.908    c5.899-5.519,7.234-12.182,3.997-19.986c-3.23-7.421-8.847-11.132-16.844-11.136h-73.091V36.543c0-4.948-1.811-9.231-5.421-12.847    c-3.62-3.617-7.901-5.426-12.847-5.426h-73.096c-4.946,0-9.229,1.809-12.847,5.426c-3.615,3.616-5.424,7.898-5.424,12.847V164.45    h-73.089c-7.998,0-13.61,3.715-16.846,11.136c-3.234,7.801-1.903,14.467,3.999,19.986L224.692,323.479z",fill:"#FFFFFF"}})])])]):e._e(),n("span",{on:{click:e.close}},[e._v("×")])])]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"prev-v-img",on:{click:e.prev}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z",fill:"#fff"}})])]):e._e()]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"next-v-img",on:{click:e.next}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z",fill:"#fff"}})])]):e._e()]),e.thumbnails&&e.images.length>1?n("div",{staticClass:"footer-v-img"},e._l(e.images,function(t,i){return n("img",{key:i,class:{"is-selected":e.currentImageIndex==i},attrs:{src:t},on:{click:function click(t){e.select(i);}}});})):e._e(),n("div",{staticClass:"content-v-img"},[n("img",{attrs:{src:e.images[e.currentImageIndex]},on:{click:e.next}})])],1)]);},staticRenderFns:[],_scopeId:"data-v-5928e1c7",data:function data(){return{images:[],titles:[],sourceButtons:[],visibleUI:!0,currentImageIndex:0,closed:!0,uiTimeout:null,handlers:{},thumbnails:!1};},watch:{closed:function closed(e){e&&this.handlers.closed&&this.handlers.closed(),!e&&this.handlers.opened&&this.handlers.opened();}},methods:{fireChangeEvent:function fireChangeEvent(){this.handlers.changed&&this.handlers.changed(this.currentImageIndex);},close:function close(){this.closed||(document.querySelector("body").classList.remove("body-fs-v-img"),this.images=[],this.currentImageIndex=0,this.closed=!0);},next:function next(){!this.closed&&this.images.length>1&&(this.currentImageIndex+1<this.images.length?this.currentImageIndex++:this.currentImageIndex=0,this.fireChangeEvent());},select:function select(e){this.currentImageIndex=e;},prev:function prev(){!this.closed&&this.images.length>1&&(this.currentImageIndex>0?this.currentImageIndex--:this.currentImageIndex=this.images.length-1,this.fireChangeEvent());},showUI:function showUI(){var e=this;this.closed||(clearTimeout(this.uiTimeout),this.visibleUI=!0,this.uiTimeout=setTimeout(function(){e.visibleUI=!1;},3500));}},created:function created(){var e=this;window.addEventListener("keyup",function(t){27!==t.keyCode&&81!==t.keyCode||e.close(),39!==t.keyCode&&76!==t.keyCode||e.next(),37!==t.keyCode&&72!==t.keyCode||e.prev();}),window.addEventListener("scroll",function(){e.close();}),window.addEventListener("mousemove",function(){e.showUI();});}},_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n){Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i]);}}return e;},toConsumableArray=function toConsumableArray(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++){n[t]=e[t];}return n;}return Array.from(e);},addPluginAttributes=function addPluginAttributes(e,t,n){var i="pointer",a=t.arg||null,s=void 0,o=void 0,r=e.src,c=void 0,l=void 0,u={};return n.altAsTitle&&(c=e.alt),s=n.openOn,o=n.sourceButton,l=n.thumbnails,void 0!==t.value&&(i=t.value.cursor||i,a=t.value.group||a,s=t.value.openOn||s,r=t.value.src||r,c=t.value.title||c,u.opened=t.value.opened,u.closed=t.value.closed,u.changed=t.value.changed,void 0!==t.value.sourceButton&&(o=t.value.sourceButton),void 0!==t.value.thumbnails&&(l=t.value.thumbnails)),e.setAttribute("data-vue-img-src",r),a&&e.setAttribute("data-vue-img-group",a),c&&e.setAttribute("data-vue-img-title",c),o&&e.setAttribute("data-vue-img-source-button",o),l&&e.setAttribute("data-vue-img-thumbnails",l),r||console.error("v-img element missing src parameter."),e.style.cursor=i,{cursor:i,src:r,group:a,title:c,events:u,sourceButton:o,openOn:s,thumbnails:l};},install=function install(e,t){var n=e.extend(ImgScreen);t=_extends({altAsTitle:!1,sourceButton:!1,thumbnails:!1,openOn:"click"},t),e.directive("img",{update:function update(e,n,i,a){var s=void 0,o=void 0;a.data.attrs&&i.data.attrs&&(o=a.data.attrs.src!==i.data.attrs.src,t.altAsTitle&&(s=a.data.attrs.alt!==i.data.attrs.alt));var r=n.oldValue!==n.value;(o||s||r)&&addPluginAttributes(e,n,t);},bind:function bind(i,a){var s=addPluginAttributes(i,a,t),o=window.vueImg;if(!o){var r=document.createElement("div");r.setAttribute("id","imageScreen"),document.querySelector("body").appendChild(r),o=window.vueImg=new n().$mount("#imageScreen");}i.addEventListener(s.openOn,function(){var t=void 0;t=i.dataset.vueImgGroup?[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+i.dataset.vueImgGroup+'"]'))):[i],e.set(o,"images",t.map(function(e){return e.dataset.vueImgSrc;})),e.set(o,"titles",t.map(function(e){return e.dataset.vueImgTitle;})),e.set(o,"sourceButtons",t.map(function(e){return"true"===e.dataset.vueImgSourceButton;})),e.set(o,"thumbnails","true"===i.dataset.vueImgThumbnails),e.set(o,"currentImageIndex",t.indexOf(i)),e.set(o,"handlers",s.events),e.set(o,"closed",!1);});}});};"undefined"!=typeof window&&window.Vue&&window.Vue.use(install);/* harmony default export */var v_img=install;// EXTERNAL MODULE: ./node_modules/vue-scrollto/vue-scrollto.js
var vue_scrollto=__webpack_require__("bm7V");var vue_scrollto_default=/*#__PURE__*/__webpack_require__.n(vue_scrollto);// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.esm.js
var vue_lazyload_esm=__webpack_require__("AXdl");// CONCATENATED MODULE: ./src/main.js
/* eslint-disable no-new */ /* eslint-disable no-undef */ /* eslint-disable no-unused-vars */ // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Swup from 'swup'
// Cleans out range screen sizes
var VueMqScreens=_.chain(tailwind["screens"]).mapValues(function(o){if(!(o instanceof Object)){return parseInt(o);}}).pickBy(_.identity).value();vue_esm["default"].use(vue_inview_min_default.a);vue_esm["default"].use(vue_countup_default.a);vue_esm["default"].use(dist,{tagName:'icon'});vue_esm["default"].use(v_show_slide_esm["a"/* default */]);vue_esm["default"].use(vue_mq_es["a"/* default */],{breakpoints:VueMqScreens});vue_esm["default"].use(v_img);vue_esm["default"].use(vue_scrollto_default.a,{container:'body',duration:500,easing:'ease',offset:0,cancelable:true,onStart:false,onDone:false,onCancel:false,x:false,y:true});vue_esm["default"].use(vue_lazyload_esm["a"/* default */],{lazyComponent:true});vue_inview_min_default.a.offset(100);vue_esm["default"].config.productionTip=false;vue_esm["default"].prototype.$eventBus=new vue_esm["default"]();new vue_esm["default"]({el:'#app',delimiters:['${','}'],data:{mobileNavOpen:false,searchNavOpen:false},created:function created(){var _this=this;var searchHandler=function searchHandler(e){if(e.key==='/'){if(document.activeElement.nodeName!=='INPUT'){_this.$refs.search.focus();e.preventDefault();}}};document.addEventListener('keydown',searchHandler);},methods:{toggleMobileNav:function toggleMobileNav(){var _this2=this;if(this.searchNavOpen){this.searchNavOpen=false;setTimeout(function(){_this2.mobileNavOpen=true;},200);}else{this.mobileNavOpen=!this.mobileNavOpen;}},toggleSearchNav:function toggleSearchNav(){var _this3=this;if(this.mobileNavOpen){this.mobileNavOpen=false;setTimeout(function(){_this3.searchNavOpen=true;},200);}else{this.searchNavOpen=!this.searchNavOpen;}},closeAllNav:function closeAllNav(){this.mobileNavOpen=false;this.searchNavOpen=false;}}});if(document.querySelector('.code-embed-iframe')){var iframes=document.querySelectorAll('.code-embed-iframe');var iframeArray=from_default()(iframes);// default width of all iframes from their embed generator
var embedWidth=700;var getResponsiveAspectRatioPx=function getResponsiveAspectRatioPx(originalHeight,frameWidth){var additionalHeight=window.innerWidth<768?250:0;var newHeightInt=originalHeight*frameWidth/embedWidth+additionalHeight;return newHeightInt+'px';};iframeArray.forEach(function(iframe){var iframeHeight=parseInt(iframe.getAttribute('height'));var iframeWidth=iframe.clientWidth;if(!isNaN(iframeHeight)){iframe.setAttribute('height',getResponsiveAspectRatioPx(iframeHeight,iframeWidth));}});}/***/},/***/"NQsl":/***/function NQsl(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'twitter':{width:24,height:20,viewBox:'0 0 24 20',data:'<path pid="0" d="M23.646 2.312a9.537 9.537 0 0 1-2.786.776A4.928 4.928 0 0 0 22.993.36a9.617 9.617 0 0 1-3.08 1.197A4.81 4.81 0 0 0 16.37 0c-2.678 0-4.85 2.208-4.85 4.93 0 .387.042.763.125 1.124-4.032-.206-7.607-2.168-10-5.152A4.967 4.967 0 0 0 .99 3.381c0 1.71.857 3.22 2.158 4.104A4.77 4.77 0 0 1 .95 6.868v.062c0 2.388 1.672 4.381 3.892 4.834a4.785 4.785 0 0 1-2.191.085c.617 1.958 2.409 3.384 4.531 3.424A9.635 9.635 0 0 1 0 17.315a13.57 13.57 0 0 0 7.437 2.215c8.923 0 13.803-7.513 13.803-14.028 0-.213-.005-.426-.014-.638a9.935 9.935 0 0 0 2.42-2.552" _fill="#19398A" fill-rule="evenodd"/>'}});/***/},/***/"Q7M0":/***/function Q7M0(module,exports,__webpack_require__){/* eslint-disable */__webpack_require__("0eYA");__webpack_require__("MVxg");__webpack_require__("thwa");__webpack_require__("zwv9");__webpack_require__("6oFW");__webpack_require__("cOw4");__webpack_require__("WZcK");__webpack_require__("zB2J");__webpack_require__("7UW2");__webpack_require__("regJ");__webpack_require__("DDte");__webpack_require__("1ii6");__webpack_require__("ofzc");__webpack_require__("9x8b");__webpack_require__("wc5W");__webpack_require__("wLjX");__webpack_require__("nA3p");__webpack_require__("NQsl");__webpack_require__("0JL+");/***/},/***/"RKgC":/***/function RKgC(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"SN0E":/***/function SN0E(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// EXTERNAL MODULE: ./node_modules/vue-flickity/src/flickity.vue + 2 modules
var flickity=__webpack_require__("6IAB");// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GallerySlider.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var GallerySlider={components:{Flickity:flickity["a"/* default */]},props:['images','blockId'],data:function data(){return{canGoForward:true,canGoBack:false,activeIndex:0,flickityOptions:{selectedAttraction:0.15,friction:0.7,cellAlign:'left',prevNextButtons:false,pageDots:false,wrapAround:false,draggable:false,groupCells:true}};},mounted:function mounted(){var _this=this;var self=this;this.$refs.squareSlider.on('select',function(){if(this.selectedIndex===this.slides.length-1){self.canGoForward=false;}else{self.canGoForward=true;}if(this.selectedIndex===0){self.canGoBack=false;}else{self.canGoBack=true;}});setTimeout(function(){_this.$refs.squareSlider.resize();},50);},methods:{changedTo:function changedTo(index){this.gotoSlide(index);},gotoSlide:function gotoSlide(tab){switch(tab){case'prev':if(this.canGoBack){this.$refs.squareSlider.previous();}break;case'next':if(this.canGoForward){this.$refs.squareSlider.next();}break;default:this.$refs.squareSlider.selectCell(tab);break;}}},computed:{showPaginationOnDesktop:function showPaginationOnDesktop(){return this.canGoBack||this.canGoForward;}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5010e0f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GallerySlider.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-slider overflow-hidden"},[_c('div',{staticClass:"container relative"},[_c('div',{staticClass:"square-slider__mask hidden md:block absolute bg-white-80 pin-r w-screen h-full z-20"}),_vm._v(" "),_c('flickity',{ref:"squareSlider",staticClass:"flickity overflow-visible",attrs:{"options":_vm.flickityOptions}},_vm._l(_vm.images,function(image,idx){return _c('div',{key:idx,staticClass:"carousel-cell mr-6 bg-grey-lighter"},[_c('div',{staticClass:"bg-grey-lighter hover:opacity-80 transition",staticStyle:{"height":"288px","width":"288px","will-change":"opacity"}},[_c('img',{directives:[{name:"img",rawName:"v-img",value:{src:image.full,group:_vm.blockId,changed:_vm.changedTo},expression:"{\n              src: image.full,\n              group: blockId,\n              changed: changedTo\n            }"},{name:"lazy",rawName:"v-lazy",value:image.thumb,expression:"image.thumb"}],staticClass:"block"})])]);})),_vm._v(" "),_c('pagination-arrows',{staticClass:"md:absolute pin-t mt-8 md:mt-4 z-30 lg:hidden",class:{'lg-flex-important':_vm.showPaginationOnDesktop},attrs:{"canGoBack":_vm.canGoBack,"canGoForward":_vm.canGoForward},on:{"handleClick":_vm.gotoSlide}})],1)]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_GallerySlider=esExports;// CONCATENATED MODULE: ./src/components/GallerySlider.vue
function injectStyle(ssrContext){__webpack_require__("xac0");}var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(GallerySlider,components_GallerySlider,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_GallerySlider=__webpack_exports__["default"]=Component.exports;/***/},/***/"T+gj":/***/function TGj(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"WZcK":/***/function WZcK(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'footer-linkedin':{width:21,height:21,viewBox:'0 0 21 21',data:'<path pid="0" d="M0 10.491c0-1.419.276-2.778.83-4.078.552-1.3 1.3-2.413 2.24-3.339.942-.926 2.062-1.673 3.362-2.24a9.82 9.82 0 0 1 4.079-.83 10.87 10.87 0 0 1 4.079.83c1.3.537 2.413 1.284 3.34 2.24.925.956 1.672 2.07 2.24 3.339.568 1.27.844 2.63.83 4.078a10.634 10.634 0 0 1-3.07 7.44 9.958 9.958 0 0 1-3.34 2.241c-1.27.523-2.63.8-4.08.83a9.199 9.199 0 0 1-4.078-.83 12.468 12.468 0 0 1-3.362-2.24C2.1 17.02 1.352 15.898.83 14.57.305 13.24.03 11.88 0 10.49zm5.087 3.384c0 .568.202 1.046.605 1.434.404.389.882.583 1.435.583h6.768c.553 0 1.031-.194 1.434-.583.404-.388.605-.866.605-1.434V7.108c0-.568-.201-1.046-.605-1.435a1.998 1.998 0 0 0-1.434-.582H7.127a1.95 1.95 0 0 0-1.435.582 2.03 2.03 0 0 0-.605 1.435v6.767zm1.816 0V9.371c0-.06.022-.112.067-.157a.215.215 0 0 1 .157-.067H8.47c.06 0 .113.022.157.067a.215.215 0 0 1 .068.157v4.504c0 .06-.023.112-.068.157a.215.215 0 0 1-.157.067H7.127a.215.215 0 0 1-.157-.067.215.215 0 0 1-.067-.157zm0-6.117a.9.9 0 0 1 .246-.628.767.767 0 0 1 .617-.258.876.876 0 0 1 .616.258.932.932 0 0 1 .269.628.67.67 0 0 1-.27.605.79.79 0 0 1-.604.268.9.9 0 0 1-.628-.246.75.75 0 0 1-.246-.627zm4.057 1.628c.004-.027.034-.055.089-.082.328-.21.702-.314 1.12-.314.613 0 1.091.157 1.435.47.343.314.515.763.515 1.345v3.07c0 .06-.022.112-.067.157a.215.215 0 0 1-.157.067h-1.322a.298.298 0 0 1-.18-.067c-.06-.045-.082-.097-.067-.157V11.12c0-.254-.045-.433-.134-.538-.09-.105-.232-.157-.426-.157-.538 0-.807.329-.807.986v2.465c0 .06-.022.112-.067.157-.045.045-.09.067-.135.067h-1.3a.402.402 0 0 1-.201-.067c-.075-.045-.105-.097-.09-.157V9.35c0-.06.03-.112.09-.157a.243.243 0 0 1 .202-.045h1.255c.163 0 .245.081.246.244v-.005z" _fill="#FFF" fill-rule="evenodd"/>'}});/***/},/***/"YH9X":/***/function YH9X(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileDrawer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var MobileDrawer={props:['name'],data:function data(){return{open:true};},mounted:function mounted(){this.checkOpen();},watch:{$mq:function $mq(){this.checkOpen();}},computed:{arrowDirection:function arrowDirection(){return this.open?'down':'up';}},methods:{toggle:function toggle(){if(this.$mq==='sm'||this.$mq==='md'||this.$mq==='lg'){this.open=!this.open;}},checkOpen:function checkOpen(){if(this.$mq==='sm'||this.$mq==='md'||this.$mq==='lg'){this.open=false;}else{this.open=true;}}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7853c556","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileDrawer.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('h3',{staticClass:"h3 text-blue pb-2 mb-0 flex items-center justify-between border-grey-light-80 border-b lg:border-none lg:pb-0",on:{"click":_vm.toggle}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n    "),_c('icon',{staticClass:"fill-current transition lg:hidden",staticStyle:{"margin-top":"-2px"},attrs:{"name":"arrow","dir":_vm.arrowDirection,"width":"15","height":"15"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show-slide",rawName:"v-show-slide",value:_vm.open,expression:"open"}]},[_c('div',{staticClass:"pt-4 mb-6 lg:mb-0"},[_vm._t("default")],2)])]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_MobileDrawer=esExports;// CONCATENATED MODULE: ./src/components/MobileDrawer.vue
var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=null;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(MobileDrawer,components_MobileDrawer,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_MobileDrawer=__webpack_exports__["default"]=Component.exports;/***/},/***/"cOw4":/***/function cOw4(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'footer-instagram':{width:21,height:21,viewBox:'0 0 21 21',data:'<path pid="0" d="M0 10.488c0-1.42.276-2.779.83-4.078.552-1.3 1.3-2.413 2.24-3.34.942-.926 2.062-1.673 3.362-2.24A9.82 9.82 0 0 1 10.511 0a10.87 10.87 0 0 1 4.079.83c1.3.538 2.413 1.284 3.34 2.24.925.957 1.672 2.07 2.24 3.34.568 1.27.844 2.629.83 4.078a10.634 10.634 0 0 1-3.07 7.44 9.958 9.958 0 0 1-3.34 2.24c-1.27.524-2.63.8-4.08.83a9.199 9.199 0 0 1-4.078-.83 12.468 12.468 0 0 1-3.362-2.24c-.97-.912-1.718-2.032-2.24-3.362-.524-1.33-.8-2.689-.83-4.078zm10.668-4.409c1.512 0 1.692.006 2.29.033.551.026.851.118 1.051.196.265.102.453.225.652.423.198.199.32.387.423.652.078.2.17.5.196 1.052.027.597.033.776.033 2.289 0 1.513-.006 1.692-.033 2.29-.026.552-.118.852-.196 1.051a1.755 1.755 0 0 1-.423.652 1.755 1.755 0 0 1-.652.423c-.2.078-.5.17-1.052.196-.597.027-.776.033-2.29.033-1.512 0-1.692-.006-2.289-.033-.552-.026-.852-.118-1.052-.196a1.755 1.755 0 0 1-.652-.423 1.755 1.755 0 0 1-.423-.652c-.078-.2-.17-.5-.195-1.052-.028-.597-.034-.776-.034-2.289 0-1.513.006-1.692.034-2.29.025-.552.117-.852.195-1.051.102-.265.225-.453.423-.652.199-.198.387-.32.652-.423.2-.078.5-.17 1.052-.196.597-.027.777-.033 2.29-.033zm.028-.986c-1.521 0-1.712.006-2.31.034-.596.027-1.003.122-1.36.26-.368.143-.68.335-.992.646a2.746 2.746 0 0 0-.646.993c-.139.356-.234.763-.26 1.36-.028.597-.035.788-.035 2.31 0 1.52.007 1.711.034 2.309.027.596.122 1.004.26 1.36.144.368.335.68.647.992.311.312.624.503.992.646.357.139.764.234 1.36.26.598.028.789.034 2.31.034 1.522 0 1.713-.006 2.31-.033.597-.027 1.004-.122 1.36-.26.369-.144.681-.335.993-.647.311-.311.503-.624.646-.992.139-.356.233-.764.26-1.36.028-.598.034-.788.034-2.31 0-1.521-.006-1.712-.034-2.31-.027-.596-.121-1.003-.26-1.36a2.746 2.746 0 0 0-.646-.992 2.746 2.746 0 0 0-.993-.646c-.356-.138-.763-.233-1.36-.26-.597-.028-.788-.034-2.31-.034zm-.028 2.844a2.787 2.787 0 1 0 0 5.574 2.787 2.787 0 0 0 0-5.574zm0 4.645a1.858 1.858 0 1 1 0-3.716 1.858 1.858 0 0 1 0 3.716zm2.787-5.11a.464.464 0 1 1-.93 0 .464.464 0 0 1 .93 0z" _fill="#FFF" fill-rule="evenodd"/>'}});/***/},/***/"cuKG":/***/function cuKG(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryArrows.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var GalleryArrows={props:['canGoForward','canGoBack'],methods:{handleClick:function handleClick(direction){this.$emit('handleClick',direction);}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1200fa68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryArrows.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"hidden list-reset md:flex justify-between"},[_c('li',{staticClass:"mr-3 md:mr-1 lg:mr-3"},[_c('button',{staticClass:"cursor-pointer transition focus:outline-none",class:[{'hover:grow':_vm.canGoBack},{'cursor-not-allowed':!_vm.canGoBack}],on:{"click":function click($event){_vm.handleClick('prev');}}},[_c('div',[_c('icon',{staticClass:"fill-current text-blue transition",class:{'text-blue-30':!_vm.canGoBack},attrs:{"name":"gallery-arrow","dir":"left","width":"40","height":"70"}})],1)])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"cursor-pointer  transition focus:outline-none",class:[{'hover:grow':_vm.canGoForward},{'cursor-not-allowed':!_vm.canGoForward}],on:{"click":function click($event){_vm.handleClick('next');}}},[_c('div',[_c('icon',{staticClass:"fill-current text-blue transition",class:{'text-blue-30':!_vm.canGoForward},attrs:{"name":"gallery-arrow","dir":"right","width":"40","height":"70"}})],1)])])]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_GalleryArrows=esExports;// CONCATENATED MODULE: ./src/components/GalleryArrows.vue
var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=null;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(GalleryArrows,components_GalleryArrows,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_GalleryArrows=__webpack_exports__["default"]=Component.exports;/***/},/***/"h5AK":/***/function h5AK(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"hKbm":/***/function hKbm(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"nA3p":/***/function nA3p(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'search':{width:18,height:18,viewBox:'0 0 18 18',data:'<defs><path pid="0" d="M12.606 11.192l5.451 5.45-1.414 1.415-5.45-5.45a7 7 0 1 1 1.414-1.414zM7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10z" id="svgicon-search-a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon-search-b" _fill="#fff"><use xlink:href="#svgicon-search-a"/></mask><use _fill="#FFF" fill-rule="nonzero" xlink:href="#svgicon-search-a"/><g mask="url(#svgicon-search-b)" _fill="#FFF"><path pid="1" d="M-3-3h24v24H-3z"/></g></g>'}});/***/},/***/"o9j0":/***/function o9j0(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"ofzc":/***/function ofzc(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'play-circle':{width:40,height:40,viewBox:'0 0 40 40',data:'<defs><path pid="0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm-6-30v20l16-10-16-10z" id="svgicon-play-circle-a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon-play-circle-b" _fill="#fff"><use xlink:href="#svgicon-play-circle-a"/></mask><use _fill="#FFF" xlink:href="#svgicon-play-circle-a"/><g mask="url(#svgicon-play-circle-b)" _fill="#FFF"><path pid="1" d="M0 0h40v40H0z"/></g></g>'}});/***/},/***/"pC1k":/***/function pC1k(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"qeuW":/***/function qeuW(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ReadMore.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var ReadMore={props:['placeholder'],data:function data(){return{open:true};},mounted:function mounted(){this.checkOpen();},watch:{$mq:function $mq(){this.checkOpen();}},computed:{arrowMargins:function arrowMargins(){return{'mb-8 group-hover:mb-6':this.open,'mb-6 group-hover:mb-8':!this.open};},moreOrLess:function moreOrLess(){return this.open?'More':'Less';},arrowDirection:function arrowDirection(){return this.open?'down':'up';},hasCopy:function hasCopy(){return!!this.$slots.default;}},methods:{toggle:function toggle(){this.open=!this.open;},checkOpen:function checkOpen(){if(this.$mq==='sm'||this.$mq==='md'||this.$mq==='lg'){this.open=false;}else{this.open=true;}}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a7cfb26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReadMore.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-8",attrs:{"id":"readmore"}},[_c('div',{directives:[{name:"show-slide",rawName:"v-show-slide",value:!_vm.open,expression:"!open"}]},[_vm._t("default")],2),_vm._v(" "),_vm.hasCopy?_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:{el:'#readmore',offset:-150,force:!_vm.open},expression:"{ el: '#readmore', offset: -150, force: !open }"}],staticClass:"hidden focus:outline-none group w-full lg:flex flex-col items-center pb-16 relative",on:{"click":_vm.toggle}},[_c('span',{staticClass:"h5 mb-0 text-blue border-b border-transparent group-hover:border-orange"},[_vm._v("Read "+_vm._s(_vm.moreOrLess))]),_vm._v(" "),_c('icon',{staticClass:"fill-current text-blue transition absolute pin-b",class:_vm.arrowMargins,attrs:{"dir":_vm.arrowDirection,"name":"arrow","width":"24","height":"24"}})],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show-slide",rawName:"v-show-slide",value:_vm.open,expression:"open"}]},[_c('img',{staticClass:"w-full",attrs:{"src":_vm.placeholder}})])]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_ReadMore=esExports;// CONCATENATED MODULE: ./src/components/ReadMore.vue
var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=null;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(ReadMore,components_ReadMore,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_ReadMore=__webpack_exports__["default"]=Component.exports;/***/},/***/"regJ":/***/function regJ(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'linkedin':{width:23,height:24,viewBox:'0 0 23 24',data:'<path pid="0" d="M19.274 19.679H15.84v-5.547c0-1.393-.497-2.343-1.74-2.343-.948 0-1.513.64-1.762 1.26-.09.222-.112.53-.112.84v5.79H8.792s.045-9.395 0-10.366h3.434v1.467c.456-.706 1.272-1.712 3.095-1.712 2.259 0 3.953 1.482 3.953 4.667v5.944zM5.174 7.897h-.022c-1.153 0-1.897-.796-1.897-1.79 0-1.017.768-1.792 1.942-1.792 1.175 0 1.898.775 1.92 1.791 0 .995-.745 1.791-1.942 1.791zM3.459 19.68H6.89V9.313H3.458v10.366zM21.055.46H1.68C.752.461 0 1.198 0 2.106v19.667c0 .908.752 1.645 1.68 1.645h19.375c.928 0 1.68-.737 1.68-1.645V2.106c0-.908-.752-1.645-1.68-1.645z" _fill="#19398A" fill-rule="evenodd"/>'}});/***/},/***/"rxHZ":/***/function rxHZ(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"thwa":/***/function thwa(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'close':{width:18,height:18,viewBox:'0 0 18 18',data:'<g _fill="#FFF" fill-rule="nonzero"><path pid="0" d="M.086 1.5L1.5.086l16.547 16.547-1.414 1.414z"/><path pid="1" d="M18.047 1.5L16.633.086.086 16.633 1.5 18.047z"/></g>'}});/***/},/***/"vRaU":/***/function vRaU(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(global){/*

Tailwind - The Utility-First CSS Framework

A project by Adam Wathan (@adamwathan), Jonathan Reinink (@reinink),
David Hemphill (@davidhemphill) and Steve Schoger (@steveschoger).

Welcome to the Tailwind config file. This is where you can customize
Tailwind specifically for your project. Don't be intimidated by the
length of this file. It's really just a big JavaScript object and
we've done our very best to explain each section.

View the full documentation at https://tailwindcss.com.


|-------------------------------------------------------------------------------
| The default config
|-------------------------------------------------------------------------------
|
| This variable contains the default Tailwind config. You don't have
| to use it, but it can sometimes be helpful to have available. For
| example, you may choose to merge your custom configuration
| values with some of the Tailwind defaults.
|
*/ // let defaultConfig = require('tailwindcss/defaultConfig')()
/*
|-------------------------------------------------------------------------------
| Colors                                    https://tailwindcss.com/docs/colors
|-------------------------------------------------------------------------------
|
| Here you can specify the colors used in your project. To get you started,
| we've provided a generous palette of great looking colors that are perfect
| for prototyping, but don't hesitate to change them for your project. You
| own these colors, nothing will break if you change everything about them.
|
| We've used literal color names ("red", "blue", etc.) for the default
| palette, but if you'd rather use functional names like "primary" and
| "secondary", or even a numeric scale like "100" and "200", go for it.
|
*/var colors={transparent:'transparent','black-actual':'#000000',black:'#22292f',white:'#ffffff','white-80':'rgba(255, 255, 255, .8)',red:'#ff0000',// Debug
'grey-darkest':'#757573','grey-darker':'#6a6e6f','grey-dark':'#C3C9CB',grey:'#D8DFE1',// Slate
'grey-light':'#ADAFB2',// Stone
'grey-light-80':'rgba(173, 175, 178, .8)',// Stone
'grey-lighter':'#D8DFE1',// Stone 30%
orange:'#FF5C35',// Tangerine
green:'#CDDE00',// Lime
teal:'#7ADBD4',// Pacific
'teal-80':'rgba(122, 219, 212, .8)',// Pacific
blue:'#002554',// True Blue
'blue-30':'rgba(0, 37, 84, .3)',// True Blue 30%
'blue-80':'rgba(0, 37, 84, .8)',// True Blue 80%
'blue-95':'rgba(0, 37, 84, .95)',// True Blue 95%
'blue-dark':'#00375E',// Midnight
'blue-dark-95':'rgba(20, 55, 91, .95)'// Midnight
};module.exports={/*
  |-----------------------------------------------------------------------------
  | Colors                                  https://tailwindcss.com/docs/colors
  |-----------------------------------------------------------------------------
  |
  | The color palette defined above is also assigned to the "colors" key of
  | your Tailwind config. This makes it easy to access them in your CSS
  | using Tailwind's config helper. For example:
  |
  | .error { color: config('colors.red') }
  |
  */colors:colors,/*
  |-----------------------------------------------------------------------------
  | Screens                      https://tailwindcss.com/docs/responsive-design
  |-----------------------------------------------------------------------------
  |
  | Screens in Tailwind are translated to CSS media queries. They define the
  | responsive breakpoints for your project. By default Tailwind takes a
  | "mobile first" approach, where each screen size represents a minimum
  | viewport width. Feel free to have as few or as many screens as you
  | want, naming them in whatever way you'd prefer for your project.
  |
  | Tailwind also allows for more complex screen definitions, which can be
  | useful in certain situations. Be sure to see the full responsive
  | documentation for a complete list of options.
  |
  | Class name: .{screen}:{utility}
  |
  */screens:{sm:'576px',md:'768px','md-lg':{min:'768px',max:'998px'},lg:'1003px',lg2:'1100px',xl:'1212px',xxl:'1600px'},/*
  |-----------------------------------------------------------------------------
  | Fonts                                    https://tailwindcss.com/docs/fonts
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your project's font stack, or font families.
  | Keep in mind that Tailwind doesn't actually load any fonts for you.
  | If you're using custom fonts you'll need to import them prior to
  | defining them here.
  |
  | By default we provide a native font stack that works remarkably well on
  | any device or OS you're using, since it just uses the default fonts
  | provided by the platform.
  |
  | Class name: .font-{name}
  |
  */fonts:{sans:['UniversLTPro-55Roman','system-ui','BlinkMacSystemFont','-apple-system','Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue','sans-serif'],header:['sharp-sans','system-ui','BlinkMacSystemFont','-apple-system','Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue','sans-serif'],condensed:['UniversLTPro-LightCond','Calibri','sans-serif'],serif:['Constantia','Lucida Bright','Lucidabright','Lucida Serif','Lucida','DejaVu Serif','Bitstream Vera Serif','Liberation Serif','Georgia','serif'],mono:['Menlo','Monaco','Consolas','Liberation Mono','Courier New','monospace']},/*
  |-----------------------------------------------------------------------------
  | Text sizes                         https://tailwindcss.com/docs/text-sizing
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your text sizes. Name these in whatever way
  | makes the most sense to you. We use size names by default, but
  | you're welcome to use a numeric scale or even something else
  | entirely.
  |
  | By default Tailwind uses the "rem" unit type for most measurements.
  | This allows you to set a root font size which all other sizes are
  | then based on. That said, you are free to use whatever units you
  | prefer, be it rems, ems, pixels or other.
  |
  | Class name: .text-{size}
  |
  */textSizes:{xxs:'.625rem',// 10px
xs:'.75rem',// 12px
sm:'.875rem',// 14px
base:'1rem',// 16px
lg:'1.125rem',// 18px
xl:'1.25rem',// 20px
'24':'1.5rem',// 24px
'2xl':'2rem',// 32px
'3xl':'2.5rem',// 40px
'4xl':'3.5rem',// 56px
'5xl':'5.125rem'// 82px
},/*
  |-----------------------------------------------------------------------------
  | Font weights                       https://tailwindcss.com/docs/font-weight
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your font weights. We've provided a list of
  | common font weight names with their respective numeric scale values
  | to get you started. It's unlikely that your project will require
  | all of these, so we recommend removing those you don't need.
  |
  | Class name: .font-{weight}
  |
  */fontWeights:{hairline:100,thin:200,light:300,normal:400,medium:500,semibold:600,bold:700,extrabold:800,black:900},/*
  |-----------------------------------------------------------------------------
  | Leading (line height)              https://tailwindcss.com/docs/line-height
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your line height values, or as we call
  | them in Tailwind, leadings.
  |
  | Class name: .leading-{size}
  |
  */leading:{xtight:0.95,none:1,tight:1.25,normal:1.5,loose:2,xloose:3},/*
  |-----------------------------------------------------------------------------
  | Tracking (letter spacing)       https://tailwindcss.com/docs/letter-spacing
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your letter spacing values, or as we call
  | them in Tailwind, tracking.
  |
  | Class name: .tracking-{size}
  |
  */tracking:{tight:'-0.05em',normal:'0',wide:'0.05em','1px':'1px','2px':'2px','2.5px':'2.5px'},/*
  |-----------------------------------------------------------------------------
  | Text colors                         https://tailwindcss.com/docs/text-color
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your text colors. By default these use the
  | color palette we defined above, however you're welcome to set these
  | independently if that makes sense for your project.
  |
  | Class name: .text-{color}
  |
  */textColors:colors,/*
  |-----------------------------------------------------------------------------
  | Background colors             https://tailwindcss.com/docs/background-color
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your background colors. By default these use
  | the color palette we defined above, however you're welcome to set
  | these independently if that makes sense for your project.
  |
  | Class name: .bg-{color}
  |
  */backgroundColors:colors,/*
  |-----------------------------------------------------------------------------
  | Background sizes               https://tailwindcss.com/docs/background-size
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your background sizes. We provide some common
  | values that are useful in most projects, but feel free to add other sizes
  | that are specific to your project here as well.
  |
  | Class name: .bg-{size}
  |
  */backgroundSize:{auto:'auto',cover:'cover',contain:'contain'},/*
  |-----------------------------------------------------------------------------
  | Border widths                     https://tailwindcss.com/docs/border-width
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your border widths. Take note that border
  | widths require a special "default" value set as well. This is the
  | width that will be used when you do not specify a border width.
  |
  | Class name: .border{-side?}{-width?}
  |
  */borderWidths:{default:'1px','0':'0','2':'2px','4':'4px','6':'6px','8':'8px'},/*
  |-----------------------------------------------------------------------------
  | Border colors                     https://tailwindcss.com/docs/border-color
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your border colors. By default these use the
  | color palette we defined above, however you're welcome to set these
  | independently if that makes sense for your project.
  |
  | Take note that border colors require a special "default" value set
  | as well. This is the color that will be used when you do not
  | specify a border color.
  |
  | Class name: .border-{color}
  |
  */borderColors:global.Object.assign({default:colors['grey-light']},colors),/*
  |-----------------------------------------------------------------------------
  | Border radius                    https://tailwindcss.com/docs/border-radius
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your border radius values. If a `default` radius
  | is provided, it will be made available as the non-suffixed `.rounded`
  | utility.
  |
  | If your scale includes a `0` value to reset already rounded corners, it's
  | a good idea to put it first so other values are able to override it.
  |
  | Class name: .rounded{-side?}{-size?}
  |
  */borderRadius:{none:'0',sm:'.125rem',default:'.25rem',lg:'.5rem',full:'9999px'},/*
  |-----------------------------------------------------------------------------
  | Width                                    https://tailwindcss.com/docs/width
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your width utility sizes. These can be
  | percentage based, pixels, rems, or any other units. By default
  | we provide a sensible rem based numeric scale, a percentage
  | based fraction scale, plus some other common use-cases. You
  | can, of course, modify these values as needed.
  |
  |
  | It's also worth mentioning that Tailwind automatically escapes
  | invalid CSS class name characters, which allows you to have
  | awesome classes like .w-2/3.
  |
  | Class name: .w-{size}
  |
  */width:{auto:'auto',px:'1px','0':'0','1':'0.25rem','2':'0.5rem','3':'0.75rem','4':'1rem','5':'1.25rem','6':'1.5rem','8':'2rem','10':'2.5rem','12':'3rem','16':'4rem','24':'6rem','32':'8rem','36':'9rem','48':'12rem','64':'16rem','1/2':'50%','1/3':'33.33333%','2/3':'66.66667%','1/4':'25%','3/4':'75%','1/5':'20%','2/5':'40%','3/5':'60%','4/5':'80%','1/6':'16.66667%','5/6':'83.33333%','80per':'80%','90per':'90%',full:'100%',screen:'100vw'},/*
  |-----------------------------------------------------------------------------
  | Height                                  https://tailwindcss.com/docs/height
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your height utility sizes. These can be
  | percentage based, pixels, rems, or any other units. By default
  | we provide a sensible rem based numeric scale plus some other
  | common use-cases. You can, of course, modify these values as
  | needed.
  |
  | Class name: .h-{size}
  |
  */height:{auto:'auto','0':'0px',px:'1px','1':'0.25rem','2':'0.5rem','3':'0.75rem','4':'1rem','5':'1.25rem','6':'1.5rem','8':'2rem','10':'2.5rem','12':'3rem','16':'4rem','24':'6rem','32':'8rem','48':'12rem','64':'16rem',half:'50%',full:'100%',screen:'100vh'},/*
  |-----------------------------------------------------------------------------
  | Minimum width                        https://tailwindcss.com/docs/min-width
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your minimum width utility sizes. These can
  | be percentage based, pixels, rems, or any other units. We provide a
  | couple common use-cases by default. You can, of course, modify
  | these values as needed.
  |
  | Class name: .min-w-{size}
  |
  */minWidth:{'0':'0',full:'100%'},/*
  |-----------------------------------------------------------------------------
  | Minimum height                      https://tailwindcss.com/docs/min-height
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your minimum height utility sizes. These can
  | be percentage based, pixels, rems, or any other units. We provide a
  | few common use-cases by default. You can, of course, modify these
  | values as needed.
  |
  | Class name: .min-h-{size}
  |
  */minHeight:{'0':'0',full:'100%',screen:'100vh',px:'1px','1':'0.25rem','2':'0.5rem','3':'0.75rem','4':'1rem','5':'1.25rem','6':'1.5rem','8':'2rem','10':'2.5rem','12':'3rem','16':'4rem','24':'6rem','32':'8rem','48':'12rem','64':'16rem','72':'18rem','80':'20rem','120':'30rem'},/*
  |-----------------------------------------------------------------------------
  | Maximum width                        https://tailwindcss.com/docs/max-width
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your maximum width utility sizes. These can
  | be percentage based, pixels, rems, or any other units. By default
  | we provide a sensible rem based scale and a "full width" size,
  | which is basically a reset utility. You can, of course,
  | modify these values as needed.
  |
  | Class name: .max-w-{size}
  |
  */maxWidth:{xs:'20rem',sm:'30rem',md:'40rem',lg:'50rem',xl:'60rem','2xl':'70rem','3xl':'80rem','4xl':'90rem','5xl':'100rem','1/3':'30%','1/2':'50%',narrowHeading:'10em',full:'100%'},/*
  |-----------------------------------------------------------------------------
  | Maximum height                      https://tailwindcss.com/docs/max-height
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your maximum height utility sizes. These can
  | be percentage based, pixels, rems, or any other units. We provide a
  | couple common use-cases by default. You can, of course, modify
  | these values as needed.
  |
  | Class name: .max-h-{size}
  |
  */maxHeight:{full:'100%',screen:'100vh'},/*
  |-----------------------------------------------------------------------------
  | Padding                                https://tailwindcss.com/docs/padding
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your padding utility sizes. These can be
  | percentage based, pixels, rems, or any other units. By default we
  | provide a sensible rem based numeric scale plus a couple other
  | common use-cases like "1px". You can, of course, modify these
  | values as needed.
  |
  | Class name: .p{side?}-{size}
  |
  */padding:{px:'1px','0':'0','1':'0.25rem','2':'0.5rem','3':'0.75rem','4':'1rem','5':'1.25rem','workHero':'1.35rem','6':'1.5rem','8':'2rem','10':'2.5rem','12':'3rem','16':'4rem','20':'5rem','24':'6rem','28':'7rem','32':'8rem','36':'9rem','48':'12rem','72px':'72px','100':'100%'},/*
  |-----------------------------------------------------------------------------
  | Margin                                  https://tailwindcss.com/docs/margin
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your margin utility sizes. These can be
  | percentage based, pixels, rems, or any other units. By default we
  | provide a sensible rem based numeric scale plus a couple other
  | common use-cases like "1px". You can, of course, modify these
  | values as needed.
  |
  | Class name: .m{side?}-{size}
  |
  */margin:{auto:'auto',px:'1px','0':'0','1':'0.25rem','2':'0.5rem','3':'0.75rem','4':'1rem','5':'1.25rem','6':'1.5rem','7':'1.9rem','8':'2rem','10':'2.5rem','12':'3rem','16':'4rem','20':'5rem','22':'5.55rem','24':'6rem','32':'8rem','40':'10rem','48':'12rem','60':'15rem','7per':'7%','nav-sm':'83px','nav-md':'89px'},/*
  |-----------------------------------------------------------------------------
  | Negative margin                https://tailwindcss.com/docs/negative-margin
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your negative margin utility sizes. These can
  | be percentage based, pixels, rems, or any other units. By default we
  | provide matching values to the padding scale since these utilities
  | generally get used together. You can, of course, modify these
  | values as needed.
  |
  | Class name: .-m{side?}-{size}
  |
  */negativeMargin:{px:'1px','0':'0','1':'0.25rem','2':'0.5rem','3':'0.75rem','4':'1rem','5':'1.25rem','6':'1.5rem','8':'2rem','10':'2.5rem','12':'3rem','16':'4rem','20':'5rem','24':'6rem','32':'8rem','40':'10rem'},/*
  |-----------------------------------------------------------------------------
  | Shadows                                https://tailwindcss.com/docs/shadows
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your shadow utilities. As you can see from
  | the defaults we provide, it's possible to apply multiple shadows
  | per utility using comma separation.
  |
  | If a `default` shadow is provided, it will be made available as the non-
  | suffixed `.shadow` utility.
  |
  | Class name: .shadow-{size?}
  |
  */shadows:{default:'0 2px 4px 0 rgba(0,0,0,0.10)',md:'0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',lg:'0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08)',inner:'inset 0 2px 4px 0 rgba(0,0,0,0.06)',outline:'0 0 0 3px rgba(52,144,220,0.5)',none:'none'},/*
  |-----------------------------------------------------------------------------
  | Z-index                                https://tailwindcss.com/docs/z-index
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your z-index utility values. By default we
  | provide a sensible numeric scale. You can, of course, modify these
  | values as needed.
  |
  | Class name: .z-{index}
  |
  */zIndex:{auto:'auto','0':0,'10':10,'20':20,'30':30,'40':40,'50':50,'60':60,'70':70},/*
  |-----------------------------------------------------------------------------
  | Opacity                                https://tailwindcss.com/docs/opacity
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your opacity utility values. By default we
  | provide a sensible numeric scale. You can, of course, modify these
  | values as needed.
  |
  | Class name: .opacity-{name}
  |
  */opacity:{'0':'0','25':'.25','40':'.4','50':'.5','75':'.75','80':'.8','90':'.90','95':'.95','100':'1'},/*
  |-----------------------------------------------------------------------------
  | SVG fill                                   https://tailwindcss.com/docs/svg
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your SVG fill colors. By default we just provide
  | `fill-current` which sets the fill to the current text color. This lets you
  | specify a fill color using existing text color utilities and helps keep the
  | generated CSS file size down.
  |
  | Class name: .fill-{name}
  |
  */svgFill:{current:'currentColor'},/*
  |-----------------------------------------------------------------------------
  | SVG stroke                                 https://tailwindcss.com/docs/svg
  |-----------------------------------------------------------------------------
  |
  | Here is where you define your SVG stroke colors. By default we just provide
  | `stroke-current` which sets the stroke to the current text color. This lets
  | you specify a stroke color using existing text color utilities and helps
  | keep the generated CSS file size down.
  |
  | Class name: .stroke-{name}
  |
  */svgStroke:{current:'currentColor'},/*
  |-----------------------------------------------------------------------------
  | Modules                  https://tailwindcss.com/docs/configuration#modules
  |-----------------------------------------------------------------------------
  |
  | Here is where you control which modules are generated and what variants are
  | generated for each of those modules.
  |
  | Currently supported variants:
  |   - responsive
  |   - hover
  |   - focus
  |   - active
  |   - group-hover
  |
  | To disable a module completely, use `false` instead of an array.
  |
  */modules:{appearance:['responsive'],backgroundAttachment:['responsive'],backgroundColors:['responsive','hover','focus'],backgroundPosition:['responsive'],backgroundRepeat:['responsive'],backgroundSize:['responsive'],borderCollapse:[],borderColors:['responsive','hover','focus','group-hover'],borderRadius:['responsive'],borderStyle:['responsive'],borderWidths:['responsive','hover','group-hover'],cursor:['responsive'],display:['responsive','group-hover'],flexbox:['responsive'],float:['responsive'],fonts:['responsive'],fontWeights:['responsive','hover','focus'],height:['responsive'],leading:['responsive'],lists:['responsive'],margin:['responsive','group-hover'],maxHeight:['responsive'],maxWidth:['responsive'],minHeight:['responsive'],minWidth:['responsive'],negativeMargin:['responsive'],objectFit:['responsive'],opacity:['responsive','hover','group-hover'],outline:['focus'],overflow:['responsive'],padding:['responsive'],pointerEvents:['responsive','group-hover'],position:['responsive'],resize:['responsive'],shadows:['responsive','hover','focus'],svgFill:[],svgStroke:[],tableLayout:['responsive'],textAlign:['responsive'],textColors:['responsive','hover','focus','group-hover'],textSizes:['responsive'],textStyle:['responsive','hover','focus','group-hover'],tracking:['responsive'],userSelect:['responsive'],verticalAlign:['responsive'],visibility:['responsive'],whitespace:['responsive'],width:['responsive','focus'],zIndex:['responsive']},/*
  |-----------------------------------------------------------------------------
  | Plugins                                https://tailwindcss.com/docs/plugins
  |-----------------------------------------------------------------------------
  |
  | Here is where you can register any plugins you'd like to use in your
  | project. Tailwind's built-in `container` plugin is enabled by default to
  | give you a Bootstrap-style responsive container component out of the box.
  |
  | Be sure to view the complete plugin documentation to learn more about how
  | the plugin system works.
  |
  */plugins:[__webpack_require__("gDGG")({grids:[5,6,7,10,12],gaps:{'0':'0','1':'2.43902%'}}),__webpack_require__("JK0N")({standard:'all .3s ease',transitions:{fast:'all .2s ease',faster:'all .1s ease'}}),__webpack_require__("/0Hi")({range:{from:-2,to:2},variants:['responsive']}),__webpack_require__("tj3a")({triangles:{select:{direction:'down',color:colors['blue'],size:[10,6]},nav:{direction:'up',color:colors['blue'],right:'50%',size:[23,10]}}}),__webpack_require__("3/pW")({name:'spinner',color:colors['grey-light'],size:'2em',border:'3px'}),__webpack_require__("EXEe")({ratios:{square:[1,1],'6/4':[6,4],'16/9':[16,9],'4/3':[4,3],'21/9':[21,9],'5/3':[5,3],hero:[1440,640]},variants:['responsive']})],/*
  |-----------------------------------------------------------------------------
  | Advanced Options         https://tailwindcss.com/docs/configuration#options
  |-----------------------------------------------------------------------------
  |
  | Here is where you can tweak advanced configuration options. We recommend
  | leaving these options alone unless you absolutely need to change them.
  |
  */options:{prefix:'',important:false,separator:':'}/* WEBPACK VAR INJECTION */};}).call(exports,__webpack_require__("DuR2"));/***/},/***/"vaql":/***/function vaql(module,exports,__webpack_require__){var map={"./CountUp.vue":"xRpK","./EmbedCode.vue":"/902","./FilterSquares.vue":"Gd+1","./GalleryArrows.vue":"cuKG","./GallerySlider.vue":"SN0E","./HoverSquare.vue":"6QXh","./ImageSlider.vue":"91E/","./LinkWithArrow.vue":"x+2Q","./MainNav.vue":"EjQ4","./MobileDrawer.vue":"YH9X","./MobileNav.vue":"JyMW","./PaginatedTab.vue":"Cv/O","./PaginatedTabs.vue":"/iwA","./PaginationArrows.vue":"Aww3","./ReadMore.vue":"qeuW","./SquareSlider.vue":"wnMx","./VideoModal.vue":"CgCn"};function webpackContext(req){return __webpack_require__(webpackContextResolve(req));}function webpackContextResolve(req){var id=map[req];if(!(id+1))// check for number or string
throw new Error("Cannot find module '"+req+"'.");return id;}webpackContext.keys=function webpackContextKeys(){return Object.keys(map);};webpackContext.resolve=webpackContextResolve;module.exports=webpackContext;webpackContext.id="vaql";/***/},/***/"wLjX":/***/function wLjX(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'search-thin':{width:35,height:35,viewBox:'0 0 35 35',data:'<path pid="0" d="M24.632 23.218l10.087 10.087-1.414 1.414-10.087-10.087a13.946 13.946 0 0 1-9.168 3.418c-7.732 0-14-6.268-14-14s6.268-14 14-14 14 6.268 14 14c0 3.506-1.289 6.711-3.418 9.168zM14.05 26.05c6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12 0 6.628 5.373 12 12 12z" _fill="#717073" fill-rule="nonzero"/>'}});/***/},/***/"wc5W":/***/function wc5W(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'search-nav':{width:18,height:18,viewBox:'0 0 18 18',data:'<defs><path pid="0" d="M12.606 11.192l5.451 5.45-1.414 1.415-5.45-5.45a7 7 0 1 1 1.414-1.414zM7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10z" id="svgicon-search-nav-a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon-search-nav-b" _fill="#fff"><use xlink:href="#svgicon-search-nav-a"/></mask><use _fill="#FFF" fill-rule="nonzero" xlink:href="#svgicon-search-nav-a"/><g mask="url(#svgicon-search-nav-b)" _fill="#FFF"><path pid="1" d="M-3-3h24v24H-3z"/></g></g>'}});/***/},/***/"wnMx":/***/function wnMx(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// EXTERNAL MODULE: ./node_modules/vue-flickity/src/flickity.vue + 2 modules
var flickity=__webpack_require__("6IAB");// EXTERNAL MODULE: ./src/components/HoverSquare.vue + 2 modules
var HoverSquare=__webpack_require__("6QXh");// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SquareSlider.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var SquareSlider={components:{Flickity:flickity["a"/* default */],HoverSquare:HoverSquare["default"]},props:['items','color'],data:function data(){return{canGoForward:true,canGoBack:false,activeIndex:0,flickityOptions:{selectedAttraction:0.15,friction:0.7,cellAlign:'left',prevNextButtons:false,pageDots:false,wrapAround:false,draggable:false,groupCells:true}};},mounted:function mounted(){var _this=this;var self=this;this.$refs.squareSlider.on('select',function(){if(this.selectedIndex===this.slides.length-1){self.canGoForward=false;}else{self.canGoForward=true;}if(this.selectedIndex===0){self.canGoBack=false;}else{self.canGoBack=true;}});setTimeout(function(){_this.$refs.squareSlider.resize();},50);},methods:{gotoSlide:function gotoSlide(tab){switch(tab){case'prev':if(this.canGoBack){this.$refs.squareSlider.previous();}break;case'next':if(this.canGoForward){this.$refs.squareSlider.next();}break;default:this.$refs.squareSlider.selectCell(tab);break;}}},computed:{showPaginationOnDesktop:function showPaginationOnDesktop(){return this.canGoBack||this.canGoForward;}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8a8e0be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SquareSlider.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-slider"},[_c('div',{staticClass:"container relative"},[_c('div',{staticClass:"square-slider__mask hidden md:block absolute pin-r w-screen h-full z-20 opacity-80",class:_vm.color}),_vm._v(" "),_c('flickity',{ref:"squareSlider",staticClass:"flickity overflow-visible",attrs:{"options":_vm.flickityOptions}},_vm._l(_vm.items,function(item,idx){return _c('div',{key:idx,staticClass:"carousel-cell mr-6"},[_c('hover-square',{staticClass:"relative",attrs:{"heading":item.heading,"bgImage":item.bgImage,"subheading":item.subheading,"body":item.body,"footer":item.footer}})],1);})),_vm._v(" "),_c('pagination-arrows',{staticClass:"md:absolute pin-t mt-8 md:mt-4 z-30 lg:hidden",class:{'lg-flex-important':_vm.showPaginationOnDesktop},attrs:{"canGoBack":_vm.canGoBack,"canGoForward":_vm.canGoForward},on:{"handleClick":_vm.gotoSlide}})],1)]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_SquareSlider=esExports;// CONCATENATED MODULE: ./src/components/SquareSlider.vue
function injectStyle(ssrContext){__webpack_require__("o9j0");}var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(SquareSlider,components_SquareSlider,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_SquareSlider=__webpack_exports__["default"]=Component.exports;/***/},/***/"x+2Q":/***/function x2Q(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LinkWithArrow.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var LinkWithArrow={props:{href:{required:true,type:String},color:{default:'blue',type:String},direction:{default:'right',type:String,validator:function validator(value){return['right','left','up','down'].indexOf(value)!==-1;}},position:{default:'after',type:String,validator:function validator(value){return['before','after'].indexOf(value)!==-1;}},moveArrow:{default:true,type:Boolean},target:{type:String}},computed:{isButton:function isButton(){return this.href.includes('player.vimeo.com')||this.href.includes('youtube.com/embed');}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e54e3230","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkWithArrow.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm.isButton?_c('button',{staticClass:"cursor-pointer link-with-arrow",class:'text-'+_vm.color+' position-'+_vm.position,staticStyle:{"text-decoration":"none"},on:{"click":function click($event){_vm.$eventBus.$emit('openVideoModal',_vm.href);}}},[_vm.position==='before'?_c('icon',{staticClass:"mr-1 fill-current transition",class:'text-'+_vm.color,attrs:{"name":"arrow","dir":_vm.direction,"width":"12","height":"12"}}):_vm._e(),_vm._v(" "),_c('span',[_vm._t("default")],2),_vm._v(" "),_vm.position==='after'?_c('icon',{staticClass:"ml-1 fill-current transition",class:'text-'+_vm.color,attrs:{"name":"arrow","dir":_vm.direction,"width":"12","height":"12"}}):_vm._e()],1):_c('a',{staticClass:"cursor-pointer inline-block link-with-arrow",class:'text-'+_vm.color+' position-'+_vm.position,staticStyle:{"text-decoration":"none"},attrs:{"href":this.href,"target":this.target}},[_vm.position==='before'?_c('icon',{staticClass:"mr-1 fill-current transition",class:'text-'+_vm.color,attrs:{"name":"arrow","dir":_vm.direction,"width":"12","height":"12"}}):_vm._e(),_vm._v(" "),_c('span',[_vm._t("default")],2),_vm._v(" "),_vm.position==='after'?_c('icon',{staticClass:"ml-1 fill-current transition",class:'text-'+_vm.color,attrs:{"name":"arrow","dir":_vm.direction,"width":"12","height":"12"}}):_vm._e()],1);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_LinkWithArrow=esExports;// CONCATENATED MODULE: ./src/components/LinkWithArrow.vue
var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=null;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(LinkWithArrow,components_LinkWithArrow,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_LinkWithArrow=__webpack_exports__["default"]=Component.exports;/***/},/***/"xRpK":/***/function xRpK(module,__webpack_exports__,__webpack_require__){Object.defineProperty(__webpack_exports__,"__esModule",{value:true});// EXTERNAL MODULE: ./node_modules/vue-countup-v2/dist/vue-countup.js
var vue_countup=__webpack_require__("iXLo");var vue_countup_default=/*#__PURE__*/__webpack_require__.n(vue_countup);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CountUp.vue
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var CountUp={props:['countTo'],data:function data(){return{canCount:false};},components:{ICountUp:vue_countup_default.a},mounted:function mounted(){var _this=this;setTimeout(function(){_this.canCount=true;},750);},methods:{count:function count(){if(this.canCount){this.$refs.countUp.update(this.countTo);}}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-515c9c74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountUp.vue
var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ICountUp',{directives:[{name:"inview",rawName:"v-inview:enter",value:_vm.count,expression:"count",arg:"enter"}],ref:"countUp",attrs:{"startVal":0,"endVal":0,"decimals":0,"duration":3}});};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};var components_CountUp=esExports;// CONCATENATED MODULE: ./src/components/CountUp.vue
var normalizeComponent=__webpack_require__("VU/8");/* script */ /* template */ /* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=null;/* scopeId */var __vue_scopeId__=null;/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(CountUp,components_CountUp,__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */var src_components_CountUp=__webpack_exports__["default"]=Component.exports;/***/},/***/"xac0":/***/function xac0(module,exports){// removed by extract-text-webpack-plugin
/***/},/***/"zB2J":/***/function zB2J(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'footer-twitter':{width:21,height:21,viewBox:'0 0 21 21',data:'<path pid="0" d="M-.008 10.491c0-1.419.276-2.778.829-4.078.553-1.3 1.3-2.413 2.241-3.339.941-.926 2.062-1.673 3.362-2.24a9.82 9.82 0 0 1 4.079-.83 10.87 10.87 0 0 1 4.078.83c1.3.537 2.413 1.284 3.34 2.24.926.956 1.673 2.07 2.24 3.339.569 1.27.845 2.63.83 4.078a10.634 10.634 0 0 1-3.07 7.44 9.958 9.958 0 0 1-3.34 2.241c-1.27.523-2.63.8-4.078.83a9.199 9.199 0 0 1-4.08-.83 12.468 12.468 0 0 1-3.361-2.24c-.971-.912-1.718-2.033-2.241-3.362-.523-1.33-.8-2.69-.83-4.079zm4.258 4.46c0 .075.03.134.09.18.104.074.306.193.605.358 1.09.552 2.233.829 3.428.829 1.495 0 2.847-.381 4.057-1.143a7.477 7.477 0 0 0 1.569-1.345 6.44 6.44 0 0 0 1.075-1.635 9.569 9.569 0 0 0 .583-1.704 7.095 7.095 0 0 0 .202-1.635v-.247c.523-.388.926-.822 1.21-1.3a.257.257 0 0 0 .045-.145c0-.053-.023-.101-.067-.146a.215.215 0 0 0-.157-.067l-.157.067-.493.18c.12-.15.239-.337.358-.56.12-.225.18-.382.18-.472 0-.044-.023-.09-.068-.134-.044-.045-.09-.067-.134-.067a.423.423 0 0 0-.134.022c-.538.284-1.016.478-1.435.583a2.657 2.657 0 0 0-1.95-.807 2.62 2.62 0 0 0-1.95.83c-.537.552-.806 1.202-.806 1.949 0 .09.007.202.022.336-1.569-.15-2.92-.74-4.056-1.77-.21-.195-.463-.456-.762-.785a.279.279 0 0 0-.202-.09c-.075 0-.127.038-.157.113-.269.358-.403.821-.403 1.39 0 .656.216 1.24.65 1.747-.015 0-.09-.03-.224-.09a.542.542 0 0 0-.236-.067.228.228 0 0 0-.168.067.34.34 0 0 0-.09.18c0 .478.128.926.382 1.344.254.419.575.755.963 1.009h-.09c-.014-.015-.048-.023-.1-.023-.053 0-.101.023-.146.067-.045.045-.067.09-.067.135l.022.09c.15.463.404.859.762 1.187.359.329.77.545 1.233.65a4.713 4.713 0 0 1-2.577.74l-.314-.023a.659.659 0 0 1-.157-.022.344.344 0 0 0-.146-.011.26.26 0 0 0-.123.078.215.215 0 0 0-.067.157z" _fill="#FFF" fill-rule="evenodd"/>'}});/***/},/***/"zwv9":/***/function zwv9(module,exports,__webpack_require__){/* eslint-disable */var icon=__webpack_require__("0QuU");icon.register({'facebook':{width:11,height:24,viewBox:'0 0 11 24',data:'<path pid="0" d="M10.736 7.662H7.08V5.206c0-.922.596-1.137 1.016-1.137h2.58V.014L7.124 0C3.178 0 2.281 3.024 2.281 4.959v2.703H0v4.177h2.28v11.822h4.8V11.84h3.236l.419-4.177z" _fill="#19398A" fill-rule="evenodd"/>'}});/***/}},["NHnr"]);

}());



// WEBPACK FOOTER //
// static/js/app.b0a17a3c386b184916da.js